/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-undef */
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import Cookies from 'universal-cookie'
import { useAppKitAccount } from '@reown/appkit/react'
import '../App.css'
import InfoAbi from '../config/InfoAbi.json'
import ChadAbi from '../config/ChadPumpAbi.json'
import ChadAbiV2 from '../config/ChadPumpAbiV2.json'
import TokenAbi from '../config/TokenAbi.json'
import '../styles/MainContainer.css'
import {
  readContract,
  writeContract,
  simulateContract,
  waitForTransactionReceipt
} from '@wagmi/core'
import Web3 from 'web3'
import { toast } from 'react-hot-toast'
import bnb from '../icons/ETH-logo.svg'
import arbitrum from '../icons/arbitrum.svg'
import eth from '../icons/ETH.svg'
import pol from '../icons/polygon.svg'
import tao from '../icons/tao.svg'
import hotkey from '../icons/hotkeyswap.svg'
import TopBar from '../components/TopBar'
import TokenDetails from '../components/TokenDetails'
import Footer from '../components/Footer'
import { useQueryParam, StringParam } from 'use-query-params'
import MyChart from '../components/Chart.jsx'
import { SignMessage } from './SignMessage.jsx'
import CopyIcon from '../icons/copy.svg'
import rot13 from '../../utils/encode.ts'
import Jazzicon, { jsNumberForAddress } from 'react-jazzicon'
import { Link } from 'react-router-dom'
import {
  web3Clients,
  imageUrl,
  apiUrl,
  ethPriceApiUrl,
  scanApiLinks,
  apiKeys,
  scanLinks,
  chainNames,
  coinNames,
  chainNames1
} from '../utils/constants.ts'
import {
  getDefaultAddress,
  getHotKeyAddress,
  getInfoAddress
} from '../utils/addressHelpers.ts'
import TokenLogoImage from '../components/TokenLogoImage.jsx'
import buildBuyLink from '../utils/buildBuyLink.ts'
import { fetchDevAddress } from '../utils/pumpMetadata.ts'
import { wagmiAdapter } from '../App.jsx'
// Lightweight spinner to satisfy ClipLoader usage without extra deps
const ClipLoader = ({ size = 16, color = '#ffffff', className = '' }) => (
  <span
    className={`inline-block animate-spin border-2 border-t-transparent rounded-full ${className}`}
    style={{ width: size, height: size, borderColor: color }}
    aria-label="loading"
    role="status"
  />
)

const ethIcon = {
  1: eth,
  56: bnb,
  11155111: eth,
  8453: eth,
  137: pol,
  964: tao,
  42161: arbitrum
}

// --- Safe helpers for query params & chain-indexed lookups ---
const safeIncludes = (v, sub) => typeof v === 'string' && v.includes(sub)

// Utility that tries numeric, string, and raw chainId keys gracefully
const makeChainGetters = chainIdRaw => {
  const chainIdNum = Number(chainIdRaw)
  return {
    chainIdNum,
    getFrom: obj =>
      (obj &&
        (obj[chainIdNum] ?? obj[String(chainIdNum)] ?? obj[chainIdRaw])) ??
      undefined
  }
}

const App = () => {
  let [addressDatasRaw] = useQueryParam('address', StringParam)
  let ChadAddress = ''
  let ref = ''
  if (safeIncludes(addressDatasRaw, '/?ref=')) {
    ChadAddress = addressDatasRaw.split('/?ref=')[0]
    ref = addressDatasRaw.split('/?ref=')[1]
  } else if (typeof addressDatasRaw === 'string') {
    ChadAddress = addressDatasRaw
  }

  const { address, isConnected } = useAppKitAccount()

  let [chainId] = useQueryParam('chain', StringParam)
  let [versionParam] = useQueryParam('version', StringParam)
  const { chainIdNum, getFrom } = useMemo(
    () => makeChainGetters(chainId),
    [chainId]
  )
  // Back-compat alias for legacy code paths
  const currentChainId = chainIdNum

  const versionParamNormalized = useMemo(
    () => (versionParam ? String(versionParam).toLowerCase() : ''),
    [versionParam]
  )

  // Resolved per-chain helpers (prefer numeric keys, fall back to string/raw)
  const w3 = getFrom(web3Clients)
  const ETH_PRICE_URL = getFrom(ethPriceApiUrl)
  const SCAN_API = getFrom(scanApiLinks)
  const SCAN_LINK = getFrom(scanLinks)
  const COIN_NAME = getFrom(coinNames)
  const CHAIN_NAME = getFrom(chainNames)
  const CHAIN_NAME1 = getFrom(chainNames1)

  const infoAddress = useMemo(
    () => (chainIdNum ? getInfoAddress(chainIdNum) : ''),
    [chainIdNum]
  )
  const hasInfoContract = useMemo(() => {
    try {
      return Boolean(infoAddress && Web3.utils.isAddress(infoAddress))
    } catch {
      return false
    }
  }, [infoAddress])
  const versionType = versionParamNormalized || (hasInfoContract ? 'v4' : 'v2')
  const isV2Version = versionType === 'v2'
  const pumpAbi = useMemo(
    () => (isV2Version ? ChadAbiV2 : ChadAbi),
    [isV2Version]
  )
  const usesInfoFlow = hasInfoContract && !isV2Version

  const [tokenName, setTokenName] = useState('')
  const [tokenSymbol, setTokenSymbol] = useState('')
  const [tokenDecimals, setTokenDecimals] = useState(18)
  const [maxLimit, setMaxLimit] = useState(1)
  const [tokenAddress, setTokenAddress] = useState('')
  const [devAddress, setDevAddress] = useState('')
  const [virtualLp, setVirtualLiquidiity] = useState(0)
  const [maxBuyAmount, setMaxBuyAmount] = useState(0)
  const [chatHistory, setChatHistory] = useState([])
  // Ensure default value is 'asc'
  const [chatSortOrder, setChatSortOrder] = useState('asc')
  const [tradeSortOrder, setTradeSortOrder] = useState('desc')

  useEffect(() => {
    setChatHistory(chatHistory =>
      [...chatHistory].sort((a, b) =>
        chatSortOrder === 'asc'
          ? a.timestamp - b.timestamp
          : b.timestamp - a.timestamp
      )
    )
  }, [chatSortOrder])

  const [chatContent] = useState('')
  const [tokenAmount, setAmount] = useState()
  const [tokenOutAmount, setTokenOutAmount] = useState(0)
  let [accountBalance, setAccountBalance] = useState(0)
  let [tokenBalance, setTokenBalance] = useState(0)
  let [tokenAllowance, setTokenAllowance] = useState(0)
  const [virtualTokenLp, setVirtualTokenLp] = useState()
  const [tokenPrice, setTokenPrice] = useState(0)
  let [creating, setCreating] = useState(false)
  let [collecting, setCollecting] = useState(false)
  const [website, setWebsite] = useState()
  const [twitter, setTwitter] = useState()
  const [telegram, setTelegram] = useState()
  const [createdTime, setCreatedTime] = useState(null)
  const [inputToken, setInputToken] = useState('ETH')
  const [tokenHolders, setTokenHolders] = useState([])
  const [currentHolderPage, setCurrentHolderPage] = useState(1)
  const holderItemsPerPage = 10

  const handleHolderPageChange = useCallback(newPageNumber => {
    setCurrentHolderPage(newPageNumber)
  }, [])
  const [holderDatas, setTokenHolderDatas] = useState()
  const [transactions, setTransactions] = useState([])
  const [transactionDatas, setTransactionDatas] = useState([])
  const [ethPrice, setEthPrice] = useState()
  useEffect(() => {
    setTransactionDatas(prev => {
      const sorted = [...prev].sort((a, b) => {
        const aTime = a?.rawTimestamp || 0
        const bTime = b?.rawTimestamp || 0
        return tradeSortOrder === 'asc' ? aTime - bTime : bTime - aTime
      })
      return sorted
    })
  }, [tradeSortOrder])
  const [tokenPriceDatas, setTokenPriceDatas] = useState()
  const [lpCreated, setLpCreated] = useState(false)
  const [chartType, setChartType] = useState('native')
  // Toggle between Market Cap (USD) and Price (USD) views for the native chart
  const [chartMode, setChartMode] = useState('mcap') // 'mcap' | 'price'
  // Fit bump counter for native chart refit
  const [fitBump, setFitBump] = useState(0)
  // Keep both charts alive: mount immediately so they can load in parallel

  // Keep a stable Dexscreener iframe URL so React doesn't re‑mount it when we toggle views
  const dexSrc = useMemo(() => {
    if (chainId === '964') return null
    if (!CHAIN_NAME1 || !tokenAddress) return null
    return `https://dexscreener.com/${CHAIN_NAME1}/${tokenAddress}?embed=1&trades=0&info=0&theme=dark`
  }, [chainId, CHAIN_NAME1, tokenAddress])

  const supportsDexscreener = chainId !== '964' && Boolean(dexSrc)

  const chartSeriesData = useMemo(() => {
    try {
      if (!Array.isArray(tokenPriceDatas) || tokenPriceDatas.length === 0)
        return []
      // --- Instrumentation: probe last 5 rows to disambiguate price vs mcap and USD vs ETH ---
      // Price probe block removed (cleaned logging)

      // Choose a timestamp for index i: prefer tx time, fall back to synthetic minute cadence
      // Helper to get a timestamp for index i (prefer real tx timestamps; else synthetic minutes)
      const getTxTime = i => {
        if (!Array.isArray(transactions) || !transactions.length) return null
        const tx = transactions[transactions.length - 1 - i]
        if (!tx) return null
        const tsRaw = Number(tx?.timeStamp ?? tx?.timestamp)
        if (Number.isFinite(tsRaw) && tsRaw > 0) return Math.floor(tsRaw)
        return null
      }

      const normalizeTime = (raw, fallbackIdx) => {
        const toSec = value => {
          const n = Number(value)
          if (!Number.isFinite(n) || n <= 0) return null
          return n > 1e12 ? Math.floor(n / 1000) : Math.floor(n)
        }
        const fromPrice = toSec(raw)
        if (fromPrice != null) return fromPrice
        const fromTx = getTxTime(fallbackIdx)
        if (fromTx != null) return fromTx
        return 60 * (fallbackIdx + 1)
      }

      const len = tokenPriceDatas.length

      // Per‑minute base‑token volume buckets used by both candle and line modes
      // We also track buy/sell splits so the main chart can colorize volume later
      // Key = minuteStart (sec), Value = base units (not USD)
      // Prepare per-minute volume buckets (base-token units, lightweight)
      const volBuckets = Object.create(null)
      const fromWei = x => {
        if (x == null) return 0
        const n = typeof x === 'bigint' ? Number(x) : Number(x)
        return Number.isFinite(n) ? n / 1e18 : 0
      }
      // Split buy/sell volume buckets (base units)
      const buyBuckets = Object.create(null)
      const sellBuckets = Object.create(null)

      // 1) Build **price points** from explicit USD/price fields only; ignore non‑price amounts
      const points = []
      for (let i = 0; i < len; i++) {
        const priceEntry = tokenPriceDatas[tokenPriceDatas.length - 1 - i]
        if (!priceEntry) continue
        const time = normalizeTime(
          priceEntry.time ?? priceEntry.timestamp ?? priceEntry.t,
          i
        )
        if (!Number.isFinite(time)) continue

        // Accumulate per‑minute base volume (for both candle/line views)
        // NOTE: amount is in base units; convert from wei once.
        try {
          const amtBase = fromWei(priceEntry.amount)
          if (amtBase > 0) {
            const k = Math.floor(time / 60) * 60
            volBuckets[k] = (volBuckets[k] || 0) + amtBase
          }
        } catch (_) {}
        // Also accumulate buy/sell split by matching tx at the same index
        try {
          const tx =
            Array.isArray(transactions) && transactions.length
              ? transactions[transactions.length - 1 - i]
              : null
          const side = (
            tx?.functionName ||
            tx?.method ||
            tx?.Type ||
            tx?.type ||
            ''
          )
            .toString()
            .toLowerCase()
          const k = Math.floor(time / 60) * 60
          if (side.includes('buy'))
            buyBuckets[k] = (buyBuckets[k] || 0) + amtBase
          else if (side.includes('sell'))
            sellBuckets[k] = (sellBuckets[k] || 0) + amtBase
        } catch (_) {}

        let v = null
        // USD-denominated price fields (preferred)
        if (
          priceEntry.usd != null ||
          priceEntry.priceUsd != null ||
          priceEntry.priceUSD != null ||
          priceEntry.price_usd != null
        ) {
          const u = Number(
            priceEntry.usd ??
              priceEntry.priceUsd ??
              priceEntry.priceUSD ??
              priceEntry.price_usd
          )
          v = Number.isFinite(u) ? u : null
        } else if (priceEntry.price != null) {
          const p = Number(priceEntry.price)
          v = Number.isFinite(p) ? p : null
        } else if (priceEntry.close != null) {
          const c = Number(priceEntry.close)
          v = Number.isFinite(c) ? c : null
        } else if (priceEntry.priceEth != null || priceEntry.eth != null) {
          // ETH-denominated → convert once to USD if ethPrice is known
          const p = Number(priceEntry.priceEth ?? priceEntry.eth)
          if (Number.isFinite(p)) v = ethPrice ? p * Number(ethPrice) : p
        }

        if (v == null || !Number.isFinite(v)) continue
        points.push({ time, value: v })
      }

      // Sort ascending and de‑duplicate by timestamp (keep latest value for dup times)
      points.sort((a, b) => a.time - b.time)
      const deduped = []
      let last = -Infinity
      for (const it of points) {
        if (it.time > last) {
          deduped.push(it)
          last = it.time
        } else if (it.time === last) {
          deduped[deduped.length - 1] = it
        }
      }

      if (deduped.length === 0) return []
      // Assume fixed total supply for native price derivation (Price = MC / 1e9)
      const TOTAL_SUPPLY = 1_000_000_000

      // 2) Aggregate to **1‑minute** OHLC buckets from the price points
      const bucketKey = t => Math.floor(Number(t) / 60) * 60 // minute start in seconds
      const buckets = new Map()
      for (const pt of deduped) {
        const key = bucketKey(pt.time)
        let b = buckets.get(key)
        if (!b) {
          b = {
            time: key,
            open: pt.value,
            high: pt.value,
            low: pt.value,
            close: pt.value,
            firstTime: pt.time,
            lastTime: pt.time
          }
          buckets.set(key, b)
        } else {
          // update O/H/L/C
          if (pt.time < b.firstTime) {
            b.open = pt.value
            b.firstTime = pt.time
          }
          if (pt.time > b.lastTime) {
            b.close = pt.value
            b.lastTime = pt.time
          }
          if (pt.value > b.high) b.high = pt.value
          if (pt.value < b.low) b.low = pt.value
        }
      }

      // Attach per‑minute base volume and buy/sell split to each candle bucket
      const candlesWithVol = Array.from(buckets.values())
        .map(({ time, open, high, low, close }) => ({
          time,
          open,
          high,
          low,
          close,
          volume: volBuckets[time] || 0,
          buyVolume: buyBuckets[time] || 0,
          sellVolume: sellBuckets[time] || 0
        }))
        .sort((a, b) => a.time - b.time)

      // Prepare a line‑series fallback carrying the same volume/split
      const lineWithVol = deduped.map(p => {
        const k = Math.floor(Number(p.time) / 60) * 60
        return {
          ...p,
          volume: volBuckets[k] || 0,
          buyVolume: buyBuckets[k] || 0,
          sellVolume: sellBuckets[k] || 0
        }
      })

      // 3) Prefer candles when we have ≥2 minute buckets; cap points for responsiveness
      const MAX_POINTS = 1000
      const chosen = candlesWithVol.length >= 2 ? candlesWithVol : lineWithVol
      const trimmed =
        chosen.length > MAX_POINTS
          ? chosen.slice(chosen.length - MAX_POINTS)
          : chosen

      // 4) Attach derived fields: {mcapUSD, mcapETH, priceUSD, priceETH}
      const withDerived = trimmed.map(p => {
        // Reference value for this point: candle close or line value
        const ref =
          p && typeof p === 'object'
            ? p.close ?? p.value ?? p.open ?? p.high ?? p.low
            : null
        const mcapUSD = Number.isFinite(Number(ref)) ? Number(ref) : null
        const priceUSD = mcapUSD != null ? mcapUSD / TOTAL_SUPPLY : null
        const eUsd = Number(ethPrice)
        const priceETH =
          priceUSD != null && Number.isFinite(eUsd) && eUsd > 0
            ? priceUSD / eUsd
            : null
        const mcapETH =
          mcapUSD != null && Number.isFinite(eUsd) && eUsd > 0
            ? mcapUSD / eUsd
            : null
        return {
          ...p,
          mcapUSD,
          mcapETH,
          priceUSD,
          priceETH
        }
      })

      return withDerived
    } catch (e) {
      console.warn('[BuyPage] chartSeriesData build failed', e)
      return []
    }
  }, [tokenPriceDatas, transactions, ethPrice])

  const hasChartData = useMemo(
    () => Array.isArray(chartSeriesData) && chartSeriesData.length > 1,
    [chartSeriesData]
  )

  // --- Holders Trend (mini pane) ---
  // Build a per‑minute cumulative count of unique buyers (wallets). This mirrors the main time scale
  // so the mini pane aligns visually with the price/MC chart.
  const holdersTrend = useMemo(() => {
    try {
      if (!Array.isArray(transactions) || transactions.length === 0) return []

      // Normalize across chain families (EVM vs chain 964)
      // Normalize & sort transactions by ascending time
      const normalize = tx => {
        if (!tx || typeof tx !== 'object') return null
        // Chain 964 (tao/hotkey) vs EVM
        const is964 = Number(chainId) === 964
        const ts = is964
          ? Number(tx.timestamp)
          : Number(tx.timeStamp || tx.timestamp)
        if (!Number.isFinite(ts) || ts <= 0) return null

        // Identify side (buy/sell) consistently
        let side = 'other'
        if (!is964) {
          const fn = (tx.functionName || '').toString().toLowerCase()
          const method = (tx.method || '').toString().toLowerCase()
          if (fn.includes('buytoken') || method.includes('0xdd4549b7'))
            side = 'buy'
          else if (fn.includes('selltoken') || method.includes('0x7e72fb52'))
            side = 'sell'
        } else {
          // On 964 we considered to.hash === ChadAddress as Buy in the UI table
          try {
            const toAddr = tx?.to?.hash || ''
            const fromAddr = tx?.from?.hash || ''
            if (
              toAddr &&
              toAddr.toLowerCase() === String(ChadAddress).toLowerCase()
            )
              side = 'buy'
            else if (
              fromAddr &&
              fromAddr.toLowerCase() === String(ChadAddress).toLowerCase()
            )
              side = 'sell'
          } catch (_) {}
        }

        // Maker address (the wallet initiating the trade)
        const maker = (() => {
          if (!is964) return (tx.from || '').toString().toLowerCase()
          const h = tx?.from?.hash || ''
          return h.toString().toLowerCase()
        })()

        return { ts: Math.floor(ts), side, maker }
      }

      const norm = transactions.map(normalize).filter(Boolean)
      if (norm.length === 0) return []

      // Sort by time ascending
      norm.sort((a, b) => a.ts - b.ts)

      // Accumulate unique buyer addresses over time (monotonic increasing)
      // Build per-minute cumulative unique buyers series
      const seen = new Set()
      const buckets = new Map() // key: minuteStart (sec) -> count

      const minuteKey = sec => Math.floor(sec / 60) * 60
      for (const tx of norm) {
        const key = minuteKey(tx.ts)
        if (tx.side === 'buy' && tx.maker) {
          seen.add(tx.maker)
        }
        // Record current cumulative at this minute
        buckets.set(key, seen.size)
      }

      // Ensure we output a monotonic series for all minutes that appear in txs
      const keys = Array.from(buckets.keys()).sort((a, b) => a - b)
      const out = []
      let last = 0
      for (const k of keys) {
        const val = buckets.get(k)
        last = Math.max(last, val)
        out.push({ time: k, value: last })
      }

      // Optional: cap length similar to chartSeriesData
      const MAX_POINTS = 1000
      return out.length > MAX_POINTS ? out.slice(out.length - MAX_POINTS) : out
    } catch (e) {
      console.warn('[BuyPage] holdersTrend build failed', e)
      return []
    }
  }, [transactions, chainId, ChadAddress])

  const holdersCurrentApprox = useMemo(
    () =>
      holdersTrend.length ? holdersTrend[holdersTrend.length - 1].value : 0,
    [holdersTrend]
  )

  // --- View selection ---
  // Switch between Market Cap (USD) and derived Price (USD). Price is computed as MC / 1e9.
  // Select which series the chart should render: MC (as-is) or derived Price (MC / 1e9)
  const displayedSeries = useMemo(() => {
    if (!Array.isArray(chartSeriesData)) return []
    if (chartMode === 'mcap') return chartSeriesData
    const SUPPLY = 1_000_000_000
    const toNum = x => (x == null ? null : Number(x))
    return chartSeriesData.map(p => {
      if (p && typeof p === 'object') {
        // If we already have a derived price, prefer that
        const priceUSD = toNum(p.priceUSD)
        if (priceUSD != null && Number.isFinite(priceUSD)) {
          if ('open' in p && 'close' in p) {
            // Candle case: divide each OHLC by supply to get Price candles
            const op = toNum(p.open)
            const hi = toNum(p.high)
            const lo = toNum(p.low)
            const cl = toNum(p.close)
            return {
              ...p,
              open: op != null ? op / SUPPLY : undefined,
              high: hi != null ? hi / SUPPLY : undefined,
              low: lo != null ? lo / SUPPLY : undefined,
              close: cl != null ? cl / SUPPLY : undefined
              // keep original mcap fields; priceUSD already present
            }
          }
          if ('value' in p) {
            // Line case: collapse to a single Price value per point
            return { ...p, value: priceUSD }
          }
        }
        // Fallback: compute from MC fields at this point
        if ('open' in p && 'close' in p) {
          // Candle case: divide each OHLC by supply to get Price candles
          const op = toNum(p.open)
          const hi = toNum(p.high)
          const lo = toNum(p.low)
          const cl = toNum(p.close)
          return {
            ...p,
            open: op != null ? op / SUPPLY : undefined,
            high: hi != null ? hi / SUPPLY : undefined,
            low: lo != null ? lo / SUPPLY : undefined,
            close: cl != null ? cl / SUPPLY : undefined,
            priceUSD: cl != null ? cl / SUPPLY : p.priceUSD ?? null
          }
        }
        if ('value' in p) {
          // Line case: collapse to a single Price value per point
          const v = toNum(p.value)
          const val = v != null ? v / SUPPLY : priceUSD ?? null
          return { ...p, value: val, priceUSD: val }
        }
      }
      return p
    })
  }, [chartSeriesData, chartMode])

  // --- Dev wallet trade events → chart markers ---
  // Extract historical buys/sells involving the dev wallet so Chart.jsx can render arrow markers
  // and dashed price guides. Timestamps are seconds; result is sorted ascending.
  // Developer buy/sell events for chart markers (historical)
  const devEvents = useMemo(() => {
    try {
      if (!Array.isArray(transactions) || transactions.length === 0) return []
      if (!devAddress || typeof devAddress !== 'string') return []
      const dev = devAddress.toLowerCase()

      const out = []
      const toNum = v => {
        if (v == null) return 0
        try {
          const n = typeof v === 'bigint' ? Number(v) : Number(v)
          return Number.isFinite(n) ? n : 0
        } catch {
          return 0
        }
      }
      const fromWei = x => toNum(x) / 1e18

      for (let i = 0; i < transactions.length; i++) {
        const tx = transactions[i]
        if (!tx) continue

        // Normalize addresses for EVM vs chain 964 (hotkey)
        // Normalize addresses depending on chain type
        const is964 = Number(chainId) === 964
        const from = (is964 ? tx?.from?.hash : tx?.from) || ''
        const to = (is964 ? tx?.to?.hash : tx?.to) || ''
        const fromL = from.toString().toLowerCase()
        const toL = to.toString().toLowerCase()

        // Only include events where dev wallet is directly involved
        if (fromL !== dev && toL !== dev) continue

        // Timestamp (seconds)
        const tsRaw = Number(
          is964 ? tx?.timestamp : tx?.timeStamp ?? tx?.timestamp
        )
        if (!Number.isFinite(tsRaw) || tsRaw <= 0) continue
        const time = tsRaw > 1e12 ? Math.floor(tsRaw / 1000) : Math.floor(tsRaw)

        // Infer side from method signature; fallback to direction (from dev = sell)
        // Infer side (buy/sell) from function/method or direction
        const methodStr = (
          tx?.functionName ||
          tx?.method ||
          tx?.Type ||
          tx?.type ||
          ''
        )
          .toString()
          .toLowerCase()
        let side = 'buy'
        if (
          methodStr.includes('selltoken') ||
          methodStr.includes('sell') ||
          methodStr.includes('0x7e72fb52')
        )
          side = 'sell'
        else if (
          methodStr.includes('buytoken') ||
          methodStr.includes('buy') ||
          methodStr.includes('0xdd4549b7')
        )
          side = 'buy'
        else {
          // Fallback: if dev sent tokens/value out, assume SELL; if received, assume BUY
          side = fromL === dev ? 'sell' : 'buy'
        }

        // Best-effort amount
        let amount = 0
        if (!is964) {
          amount = fromWei(tx?.value ?? tx?.amount ?? tx?.tokenAmount)
        } else {
          amount = fromWei(tx?.amount ?? tx?.value)
        }

        out.push({ time, side, amount })
      }

      // Sort ascending & cap
      out.sort((a, b) => a.time - b.time)
      const MAX = 1000
      return out.length > MAX ? out.slice(out.length - MAX) : out
    } catch (e) {
      console.warn('[BuyPage] devEvents build failed', e)
      return []
    }
  }, [transactions, devAddress, chainId])

  // Warm up Dexscreener connection once LP exists to speed up switching
  useEffect(() => {
    if (!lpCreated || !supportsDexscreener) return
    const urls = ['https://dexscreener.com', 'https://cdn.dexscreener.com']
    const links = urls.map(href => {
      const l = document.createElement('link')
      l.rel = 'preconnect'
      l.href = href
      l.crossOrigin = ''
      document.head.appendChild(l)
      return l
    })
    const dns = document.createElement('link')
    dns.rel = 'dns-prefetch'
    dns.href = 'https://dexscreener.com'
    document.head.appendChild(dns)
    return () => {
      links.forEach(l => {
        try {
          document.head.removeChild(l)
        } catch (_) {}
      })
      try {
        document.head.removeChild(dns)
      } catch (_) {}
    }
  }, [lpCreated, supportsDexscreener])
  const [accumFee, setAccumFee] = useState()
  const [volume, setVolume] = useState(0)
  const [isTokenCopied, setIsTokenCopied] = useState(false)
  const [isReferralCopied, setIsReferralCopied] = useState(false)
  const [contractAddress, setContractAddress] = useState('')
  const [description, setDescription] = useState('')

  const [refCounts, setRefCounts] = useState(0)
  const [totalRefAmounts, setTotalRefAmounts] = useState(0)
  const [refUserAmount, setRefUserAmout] = useState(0)

  useEffect(() => {
    if (lpCreated !== undefined) {
      setChartType(lpCreated && supportsDexscreener ? 'dexscreener' : 'native')
    }
  }, [lpCreated, supportsDexscreener])

  useEffect(() => {
    if (!supportsDexscreener && chartType === 'dexscreener') {
      setChartType('native')
    }
  }, [supportsDexscreener, chartType])

  // When switching to the native chart, request a few fitContent bumps to account for late layout
  // (first paint, next frame, and a short timeout). This prevents a squished initial view.
  useEffect(() => {
    if (chartType === 'native' && hasChartData) {
      // Trigger immediate bump
      setFitBump(n => n + 1)
      // Trigger another bump after next frame to catch layout changes
      requestAnimationFrame(() => {
        setFitBump(n => n + 1)
      })
      // Trigger one more after short delay to catch late sizing
      setTimeout(() => {
        setFitBump(n => n + 1)
      }, 300)
    }
  }, [chartType, hasChartData])

  const [messageText, setMessageText] = useState('')

  const [isLoading, setIsLoading] = useState(false)
  const [isFetchingData, setIsFetchingData] = useState(false)
  const [isTransactionsLoading, setIsTransactionsLoading] = useState(true)
  const [isThreadLoading, setIsThreadLoading] = useState(true)
  const [isHoldersLoading, setIsHoldersLoading] = useState(false)

  // Abort controllers for in-flight requests to avoid race conditions
  const controllersRef = useRef({
    holders: null,
    tx: null,
    api: null,
    chatInit: null,
    agentKey: null
  })

  // Simple per-token fetch guards to avoid duplicate work
  const fetchedRef = useRef({ holdersFor: null, txFor: null, apiFor: null })
  // In-flight lock for getApi to avoid overlapping periodic calls
  const getApiLockRef = useRef(false)
  // Cooldown for price polling so toggling back to native doesn't refetch instantly
  const lastPricesFetchAtRef = useRef(0)

  const [isSwapOpen, setIsSwapOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640)
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 640)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const [userChat, setUserChat] = useState([])
  const [botChat, setBotChat] = useState([])
  const [showChat, setShowChat] = useState(true)

  const [fee, setFee] = useState({ fee0: 0, fee1: 0 })

  const [activeTab, setActiveTab] = useState('buy') // buy = ETH -> Token, sell = Token -> ETH

  const scrollContainer = useRef(null)
  const focus = useRef(null)
  const hasLoadedOnceRef = useRef(false)

  const cookies = new Cookies()
  if (ref) {
    if (Web3.utils.isAddress(rot13(ref))) {
      cookies.set('ref', ref)
    }
  }
  let refAddress
  if (cookies.get('ref')) {
    if (Web3.utils.isAddress(rot13(cookies.get('ref')))) {
      refAddress = rot13(cookies.get('ref'))
    }
  } else {
    refAddress = getDefaultAddress()
  }
  const basePath = buildBuyLink(chainIdNum, ChadAddress, versionType)
  const BASE_URL = `https://hotcurves.fun${basePath}`
  const referlink = address
    ? `${BASE_URL}&ref=${rot13(address)}`
    : `${BASE_URL}&ref=`

  const copyTokenAddress = addr => async e => {
    e.stopPropagation()
    e.preventDefault()
    if (document.queryCommandSupported('copy')) {
      const ele = document.createElement('textarea')
      ele.value = addr
      document.body.appendChild(ele)
      ele.select()
      document.execCommand('copy')
      document.body.removeChild(ele)
      setIsTokenCopied(true)
      setTimeout(() => {
        setIsTokenCopied(false)
      }, 1000)
    }
  }

  // --- Chat helpers -----------------------------------------------------------
  function extractAssistantText(payload) {
    if (!payload) return ''
    if (typeof payload === 'string') return payload

    // Common simple fields
    if (payload.text) {
      return typeof payload.text === 'string'
        ? payload.text
        : payload.text?.content || ''
    }
    if (payload.reply) return payload.reply
    if (payload.response) return payload.response
    if (payload.message) return payload.message
    if (payload.assistant) return payload.assistant
    if (payload.bot)
      return typeof payload.bot === 'string'
        ? payload.bot
        : payload.bot?.content || ''

    // Nested containers frequently used by APIs
    if (payload.data) {
      const d = payload.data
      if (typeof d === 'string') return d
      if (d.text)
        return typeof d.text === 'string' ? d.text : d.text?.content || ''
      if (d.reply) return d.reply
      if (d.response) return d.response
      if (d.message) return d.message
      if (d.bot) return typeof d.bot === 'string' ? d.bot : d.bot?.content || ''
    }

    // OpenAI / compat shapes
    if (Array.isArray(payload.messages)) {
      const last = payload.messages[payload.messages.length - 1]
      if (last && (last.role === 'assistant' || last.role === 'system')) {
        return last.content || last.text || ''
      }
    }
    if (payload.choices && payload.choices[0]) {
      const c = payload.choices[0]
      if (c.message?.content) return c.message.content
      if (typeof c.text === 'string') return c.text
      if (c.delta?.content) return c.delta.content
    }

    // Generic fallbacks
    if (payload.output && typeof payload.output === 'string')
      return payload.output
    if (payload.content && typeof payload.content === 'string')
      return payload.content
    if (Array.isArray(payload.content)) {
      // e.g. [{type:'text', text:'...'}]
      const t = payload.content.find(x => x && (x.text || x.content))
      if (t) return t.text || t.content || ''
    }
    return ''
  }

  const copyReferralAddress = addr => async e => {
    e.stopPropagation()
    e.preventDefault()
    if (document.queryCommandSupported('copy')) {
      const ele = document.createElement('textarea')
      ele.value = addr
      document.body.appendChild(ele)
      ele.select()
      document.execCommand('copy')
      document.body.removeChild(ele)
      setIsReferralCopied(true)
      setTimeout(() => {
        setIsReferralCopied(false)
      }, 1000)
    }
  }

  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }

  const onCollectFee = async () => {
    try {
      if (isV2Version) {
        toast.error('Collect is not available for this token version.')
        return
      }
      setCollecting(true)
      await writeContract(wagmiAdapter.wagmiConfig, {
        address: ChadAddress,
        abi: pumpAbi,
        functionName: 'collectFee',
        gas: 700000
      })
      await delay(8000)
      toast.success('Collected successfully')
      setCollecting(false)
    } catch (e) {
      console.log(e)
      toast.error('Collecting is failed')
      setCollecting(false)
    }
  }

  const onTokenSwap = async () => {
    if (!tokenAmount || Number(tokenAmount) <= 0) {
      toast.error('Please enter a valid amount to swap.')
      return
    }

    if (inputToken === 'ETH' && Number(tokenAmount) > Number(accountBalance)) {
      toast.error(`You don't have enough ${COIN_NAME} to complete this trade.`)
      return
    }

    if (inputToken !== 'ETH' && Number(tokenAmount) > Number(tokenBalance)) {
      toast.error(
        `You don't have enough ${tokenSymbol} to complete this trade.`
      )
      return
    }

    try {
      setCreating(true)
      let swap
      let sendData
      let tokenAmountMin = tokenOutAmount * 0.8 // slippage 20%
      if (inputToken === 'ETH') {
        if (
          tokenOutAmount + Number(tokenBalance) >
          (1000000000 * maxBuyAmount) / 100
        ) {
          const exceededAmount =
            tokenOutAmount +
            Number(tokenBalance) -
            (1000000000 * maxBuyAmount) / 100
          toast.error(
            `This trade would exceed the max wallet limit by ${exceededAmount.toLocaleString()} ${tokenSymbol}.`
          )
          setCreating(false)
          return
        }
        swap = await writeContract(wagmiAdapter.wagmiConfig, {
          address: ChadAddress,
          abi: pumpAbi,
          functionName: 'buyToken',
          value: w3.utils.toWei(String(tokenAmount), 'ether'),
          args: [refAddress, w3.utils.toWei(String(tokenAmountMin), 'ether')],
          gas: 400000
        })
        // await delay(8000); // 8-second delay
        await waitForTransactionReceipt(wagmiAdapter.wagmiConfig, {
          hash: swap
        })
        sendData = {
          chainId,
          buyer: address,
          type: 'bought',
          name: tokenSymbol,
          amount: tokenAmount,
          token: tokenAddress,
          contract: contractAddress,
          timestamp: (Date.now() / 1000).toFixed(0)
        }
      } else {
        if (tokenAllowance > 0) {
          if (tokenAmount > (1000000000 * maxBuyAmount) / 100) {
            toast.error("You can't sell more than max sell limit")
            setCreating(false)

            return
          }

          swap = await writeContract(wagmiAdapter.wagmiConfig, {
            address: ChadAddress,
            abi: pumpAbi,
            functionName: 'sellToken',
            args: [
              w3.utils.toWei(String(tokenAmount), 'ether'),
              refAddress,
              w3.utils.toWei(String(tokenAmountMin), 'ether')
            ],
            chainId: Number(chainId),
            gas: 300000
          })
          // await delay(8000); // 8-second delay
          await waitForTransactionReceipt(wagmiAdapter.wagmiConfig, {
            hash: swap
          })
          sendData = {
            chainId,
            buyer: address,
            type: 'Sold',
            name: tokenSymbol,
            amount: tokenAmount,
            token: tokenAddress,
            contract: contractAddress,
            timestamp: (Date.now() / 1000).toFixed(0)
          }
        } else {
          let max =
            '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
          let approve
          let approveAddress
          approveAddress = ChadAddress
          approve = await writeContract(wagmiAdapter.wagmiConfig, {
            address: tokenAddress,
            abi: TokenAbi,
            functionName: 'approve',
            args: [approveAddress, max],
            chainId: Number(chainId),
            gas: 200000
          })
          // await delay(10000); // 10-second delay
          await waitForTransactionReceipt(wagmiAdapter.wagmiConfig, {
            hash: approve
          })
          toast.success('Successfully approved tokens')
          setCreating(false)

          return
        }
        setInputToken(inputToken)
      }
      if (sendData) {
        const response = await fetch(apiUrl + '/api/addHistory', {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json'
          },
          redirect: 'error',
          body: JSON.stringify(sendData)
        })
        if (response.status !== 200) {
          const { error } = await response.json()
          throw new Error(error)
        }
      }
      setTimeout(function () {
        setCreating(false)
      }, 5000)
      toast.success(
        `Successfully ${Number(tokenAmount).toLocaleString()} ${
          inputToken !== 'ETH' ? tokenSymbol : COIN_NAME
        } swapped`
      )
    } catch (err) {
      console.log('>>>>', err)
      if (err?.message?.includes('User rejected') || err?.code === 4001) {
        toast.error('Transaction rejected by user.')
      } else if (!tokenAmount || Number(tokenAmount) <= 0) {
        toast.error('Please enter a valid amount to swap.')
      } else if (
        inputToken === 'ETH' &&
        Number(tokenAmount) > Number(accountBalance)
      ) {
        toast.error(
          `You don't have enough ${COIN_NAME} to complete this trade.`
        )
      } else if (
        inputToken !== 'ETH' &&
        Number(tokenAmount) > Number(tokenBalance)
      ) {
        toast.error(
          `You don't have enough ${tokenSymbol} to complete this trade.`
        )
      } else if (
        tokenOutAmount + Number(tokenBalance) >
        (1000000000 * maxBuyAmount) / 100
      ) {
        const exceededAmount =
          tokenOutAmount +
          Number(tokenBalance) -
          (1000000000 * maxBuyAmount) / 100
        toast.error(
          `This trade would exceed the max wallet limit by ${exceededAmount.toLocaleString()} ${tokenSymbol}.`
        )
      } else {
        toast.error(
          'Transaction failed. Please check your wallet or try again later.'
        )
      }
      setCreating(false)
    }
  }

  useEffect(() => {
    const calcFee = async () => {
      if (isV2Version) {
        setFee({ fee0: 0, fee1: 0 })
        return
      }
      try {
        // Helper to convert BigInt or number to float with decimals
        const toNum = (bn, decimals) => {
          try {
            const n = typeof bn === 'bigint' ? Number(bn) : Number(bn)
            return n / 10 ** (decimals || 18)
          } catch {
            return 0
          }
        }
        const baseDecimals = 18
        // Always show pool total from dev/owner's perspective
        const ownerCaller =
          (devAddress && Web3.utils.isAddress(devAddress)
            ? devAddress
            : address) || undefined
        const simOwner = await simulateContract(wagmiAdapter.wagmiConfig, {
          abi: pumpAbi,
          address: ChadAddress,
          functionName: 'collectFee',
          chainId: Number(chainId),
          account: ownerCaller
        })
        const ownerR0 = simOwner?.result?.[0] ?? 0n
        const ownerR1 = simOwner?.result?.[1] ?? 0n
        const ownerF0 = toNum(ownerR0, baseDecimals)
        const ownerF1 = toNum(ownerR1, tokenDecimals)
        setFee({
          fee0: Number.isFinite(ownerF0) ? ownerF0 : 0,
          fee1: Number.isFinite(ownerF1) ? ownerF1 : 0
        })
      } catch (e) {
        // fallback for pool total
        setFee({ fee0: 0, fee1: 0 })
      }
    }
    if (lpCreated) {
      calcFee()
    } else {
      setFee({ fee0: 0, fee1: 0 })
    }
  }, [chainId, lpCreated, collecting, address, tokenDecimals, isV2Version, pumpAbi])

  useEffect(() => {
    const FetchData = async () => {
      try {
        setIsFetchingData(true)

        if (!ChadAddress || !Web3.utils.isAddress(ChadAddress)) return

        const activeChainId = chainIdNum

        const toBigIntSafe = value => {
          if (typeof value === 'bigint') return value
          if (typeof value === 'number' && Number.isFinite(value))
            return BigInt(Math.trunc(value))
          if (typeof value === 'string' && value !== '') {
            try {
              return value.startsWith('0x') ? BigInt(value) : BigInt(value)
            } catch (_) {
              return 0n
            }
          }
          if (typeof value === 'boolean') return value ? 1n : 0n
          return 0n
        }

        const toStringSafe = value => (value == null ? '' : String(value))
        const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'
        const toAddressSafe = value =>
          typeof value === 'string' && Web3.utils.isAddress(value)
            ? value
            : ZERO_ADDRESS

        const fetchViaInfo = async () => {
          const info = await readContract(wagmiAdapter.wagmiConfig, {
            address: infoAddress,
            abi: InfoAbi,
            functionName: 'getFunBasicInfo',
            args: [ChadAddress],
            chainId: activeChainId
          })
          const prices = await readContract(wagmiAdapter.wagmiConfig, {
            address: infoAddress,
            abi: InfoAbi,
            functionName: 'getAllPrices',
            args: [ChadAddress],
            chainId: activeChainId
          })

          let accumFeeAmt = 0n
          if (info?.[3]) {
            try {
              const feeRaw = await readContract(wagmiAdapter.wagmiConfig, {
                address: infoAddress,
                abi: InfoAbi,
                functionName: 'getAccumFee',
                args: [ChadAddress],
                chainId: activeChainId
              })
              accumFeeAmt = toBigIntSafe(feeRaw)
            } catch (err) {
              console.warn('getAccumFee failed:', err?.message || err)
            }
          }

          return {
            tokenDatas: info?.[0] || [],
            stringDatas: info?.[1] || [],
            addressDatas: info?.[2] || [],
            lpCreated: Boolean(info?.[3]),
            featuredTime: info?.[4] ?? 0n,
            prices: prices || [],
            accumFee: accumFeeAmt
          }
        }

        const fetchViaLegacy = async () => {
          const safeRead = async (functionName, args = []) => {
            try {
              return await readContract(wagmiAdapter.wagmiConfig, {
                address: ChadAddress,
                abi: pumpAbi,
                functionName,
                args,
                chainId: activeChainId
              })
            } catch (err) {
              console.warn(
                `[BuyPage:${functionName}] read failed`,
                err?.message || err
              )
              return null
            }
          }

          const [
            total,
            startTimestamp,
            maxBuy,
            tokenStartPrice,
            virtualTokenLp,
            virtualEthLp,
            totalRefAmounts,
            refCount,
            tokenPriceVal,
            volumeVal,
            name,
            symbol,
            websiteRes,
            twitterRes,
            telegramRes,
            discordRes,
            infoRes,
            tokenAddr,
            lpCreatedRaw,
            featuredTimeRaw,
            prices
          ] = await Promise.all([
            safeRead('total'),
            safeRead('startTimestamp'),
            safeRead('maxBuy'),
            safeRead('tokenStartPrice'),
            safeRead('virtualTokenLp'),
            safeRead('virtualEthLp'),
            safeRead('totalRefAmounts'),
            safeRead('refCount'),
            safeRead('tokenPrice'),
            safeRead('volume'),
            safeRead('name'),
            safeRead('symbol'),
            safeRead('website'),
            safeRead('twitter'),
            safeRead('telegram'),
            safeRead('discord'),
            safeRead('info'),
            safeRead('token'),
            safeRead('lpCreated'),
            safeRead('featuredTime'),
            safeRead('getAllPrices')
          ])

          let creatorAddress = ''
          try {
            const fetched = await fetchDevAddress({
              wagmiConfig: wagmiAdapter.wagmiConfig,
              contractAddress: ChadAddress,
              chainId: chainIdNum,
              versionType
            })
            creatorAddress = toAddressSafe(fetched)
            if (!creatorAddress || creatorAddress === ZERO_ADDRESS) {
              creatorAddress = ''
            }
          } catch (err) {
            console.warn('[BuyPage] creator lookup failed:', err?.message || err)
          }

          const tokenDatas = [
            toBigIntSafe(total),
            toBigIntSafe(startTimestamp),
            toBigIntSafe(maxBuy),
            toBigIntSafe(tokenStartPrice),
            toBigIntSafe(virtualTokenLp),
            toBigIntSafe(virtualEthLp),
            toBigIntSafe(totalRefAmounts),
            toBigIntSafe(refCount),
            toBigIntSafe(tokenPriceVal),
            toBigIntSafe(volumeVal)
          ]

          const stringDatas = [
            toStringSafe(name),
            toStringSafe(symbol),
            toStringSafe(websiteRes),
            toStringSafe(twitterRes),
            toStringSafe(telegramRes),
            toStringSafe(discordRes),
            toStringSafe(infoRes)
          ]

          const addressDatas = [
            ChadAddress,
            toAddressSafe(tokenAddr),
            creatorAddress
          ]

          return {
            tokenDatas,
            stringDatas,
            addressDatas,
            lpCreated: Boolean(lpCreatedRaw),
            featuredTime: toBigIntSafe(featuredTimeRaw),
            prices: Array.isArray(prices) ? prices : [],
            accumFee: 0n
          }
        }

        const data = usesInfoFlow
          ? await fetchViaInfo()
          : await fetchViaLegacy()

        const tokenDatas = Array.isArray(data.tokenDatas)
          ? data.tokenDatas
          : []
        const stringDatas = Array.isArray(data.stringDatas)
          ? data.stringDatas
          : []
        const addressDatas = Array.isArray(data.addressDatas)
          ? data.addressDatas
          : []

        setTokenPriceDatas(Array.isArray(data.prices) ? data.prices : [])
        setTokenName(stringDatas[0] || '')
        setTokenSymbol(stringDatas[1] || '')
        setWebsite(stringDatas[2] || '')
        setTwitter(stringDatas[3] || '')
        setTelegram(stringDatas[4] || '')
        setDescription(stringDatas[6] || '')

        setContractAddress(addressDatas[0] || ChadAddress)
        setTokenAddress(addressDatas[1] || '')
        setDevAddress(addressDatas[2] || '')

        setCreatedTime(Number(tokenDatas[1] ?? 0))
        setMaxLimit(Number(tokenDatas[2] ?? 0))
        setMaxBuyAmount(Number(tokenDatas[2] ?? 0))
        setVirtualTokenLp(Number(tokenDatas[4] ?? 0n) / 10 ** 18)
        setVirtualLiquidiity(Number(tokenDatas[5] ?? 0n) / 10 ** 18)
        setTokenPrice(Number(tokenDatas[8] ?? 0))
        setRefCounts(Number(tokenDatas[7] ?? 0))
        setTotalRefAmounts(Number(tokenDatas[6] ?? 0n) / 10 ** 18)
        setLpCreated(Boolean(data.lpCreated))
        setAccumFee(Number(toBigIntSafe(data.accumFee)) / 10 ** 18)

        try {
          if (ETH_PRICE_URL) {
            await fetch(ETH_PRICE_URL, {
              method: 'GET'
            }).then(async res => {
              const priceData = await res.json()
              const volumeBase = Number(tokenDatas[9] ?? 0)
              setEthPrice(priceData.USD)
              setVolume(volumeBase * priceData.USD)
            })
          }
        } catch (err) {
          console.error(err)
        }

        if (address && w3) {
          try {
            let accountBalance = await w3.eth.getBalance(address)
            accountBalance = w3.utils.fromWei(accountBalance, 'ether')
            setAccountBalance(accountBalance)
            if (inputToken === 'ETH') {
              setAmount(accountBalance)
            } else {
              setAmount(tokenBalance)
            }
            const refUserAmounts = await readContract(wagmiAdapter.wagmiConfig, {
              address: ChadAddress,
              abi: pumpAbi,
              functionName: 'refAmounts',
              args: [address],
              chainId: activeChainId
            })
            setRefUserAmout(Number(refUserAmounts) / 10 ** 18)
          } catch (err) {
            console.error(err)
          }
        }
      } catch (e) {
        console.error(e)
      } finally {
        setIsFetchingData(false)
      }
    }
    if (creating === false) {
      FetchData()
    }
  }, [
    chainId,
    creating,
    ChadAddress,
    address,
    w3,
    tokenBalance,
    inputToken,
    pumpAbi,
    hasInfoContract,
    infoAddress,
    chainIdNum,
    usesInfoFlow
  ])

  // Removed effect for inputBalance (inputBalance is unused)

  /**
   * Periodic poller for:
   *  - on‑chain prices (native chart)
   *  - live ETH price (USD conversion)
   *  - chat thread bootstrap
   *
   * Throttling:
   *  - Only polls price endpoints when native chart is visible and at least 5s elapsed.
   *  - Uses AbortController to cancel stale requests on token/route changes.
   */
  const getApi = async ({ signal } = {}) => {
    if (getApiLockRef.current) return
    getApiLockRef.current = true
    // Avoid wasted work: skip price polling while Dexscreener is active
    // Only refresh price series when native chart is visible and cooldown elapsed
    const now = Date.now()
    const shouldPollPrices =
      chartType === 'native' && now - lastPricesFetchAtRef.current > 5000
    if (shouldPollPrices) {
      try {
        const hasChadAddress = Boolean(
          ChadAddress && Web3.utils.isAddress(ChadAddress)
        )
        const priceCall = usesInfoFlow
          ? {
              address: infoAddress,
              abi: InfoAbi,
              functionName: 'getAllPrices',
              args: [ChadAddress]
            }
          : hasChadAddress
          ? {
              address: ChadAddress,
              abi: pumpAbi,
              functionName: 'getAllPrices'
            }
          : null

        if (priceCall) {
          const GetAllPrices = await readContract(wagmiAdapter.wagmiConfig, {
            ...priceCall,
            chainId: Number(chainId)
          })
          setTokenPriceDatas(GetAllPrices)
        }
      } catch (e) {
        console.error(e)
      }

      try {
        await fetch(ETH_PRICE_URL, {
          method: 'GET',
          signal
        }).then(async res => {
          let data = await res.json()
          setEthPrice(data.USD)
        })
      } catch (e) {
        console.error(e)
      }

      lastPricesFetchAtRef.current = Date.now()
    }

    try {
      if (!hasLoadedOnceRef.current) {
        setIsThreadLoading(true)
      }
      // Ensure chainId is passed as a number in the query param
      await fetch(
        apiUrl + `/api/getOne/${ChadAddress}?chainId=${Number(chainId)}`,
        {
          method: 'GET',
          signal
        }
      ).then(async res => {
        let data = await res.json()
        if (!data.message) {
          let history
          let historyData = []
          for (let i = 0; i < data?.length; i++) {
            let sender = data[i].sender
            let content = data[i].content
            const timestamp = Number(data[i].timestamp) * 1000
            const dateObj = new Date(timestamp)
            const formattedDate = dateObj
              .toLocaleString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
              })
              .replace(/,/g, '')
            let date = formattedDate
            let userAvatarUrl = imageUrl + `profile-${sender}.png`
            history = {
              Sender: sender,
              Content: content,
              Date: date,
              timestamp: Number(data[i].timestamp),
              avatar: userAvatarUrl
            }
            historyData.push(history)
          }
          setChatHistory(historyData)
        }
      })
    } catch (e) {
      console.error(e)
    } finally {
      if (!hasLoadedOnceRef.current) {
        setIsThreadLoading(false)
        hasLoadedOnceRef.current = true
      }
    }
    // get transaction
    try {
      if (ChadAddress) {
        if (Number(chainId) !== 964) {
          await fetch(
            `${SCAN_API}?module=account&action=txlist&address=${ChadAddress}&startblock=0&endblock=99999999&apikey=${getFrom(
              apiKeys
            )}`,
            // `https://api.routescan.io/v2/network/testnet/evm/${chainId}/address/${ChadAddress}/transactions`,
            {
              method: 'GET',
              signal
            }
          ).then(async res => {
            let data = await res.json()
            if (data.status === '1') {
              setTransactions(data.result.filter(item => item.isError === '0'))
            }
          })
        } else {
          await fetch(
            // `${scanApiLinks[chainId]}?module=account&action=txlist&address=${ChadAddress}&startblock=0&endblock=99999999&apiKey=${apiKeys[chainId]}`,
            `https://bittensorexplorer.hotkeyswap.com/api/v2/addresses/${ChadAddress}/transactions`,
            {
              method: 'GET',
              signal
            }
          ).then(async res => {
            let data = await res.json()
            if (data.items.length > 0) {
              setTransactions(data.items.filter(item => item.status === 'ok'))
            }
          })
        }
      }
    } catch (e) {
      console.error(e)
    }
    // get holders
    try {
      if (tokenAddress) {
        if (Number(chainId) !== 964) {
          await fetch(
            `https://deep-index.moralis.io/api/v2.2/erc20/${tokenAddress}/owners?chain=0x${Number(
              chainId
            ).toString(16)}&order=DESC`,
            // `https://api.routescan.io/v2/network/testnet/evm/${chainId}/erc20/${tokenAddress}/holders`,
            {
              method: 'GET',
              signal,
              headers: {
                accept: 'application/json',
                'X-API-Key':
                  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub25jZSI6IjIxNDczNDI5LTAyZDktNDZkYi1hYzA4LTBjMmUwM2Y0MGNmZSIsIm9yZ0lkIjoiMzc5NzM5IiwidXNlcklkIjoiMzkwMjA2IiwidHlwZSI6IlBST0pFQ1QiLCJ0eXBlSWQiOiIzMTNmMTM4Mi02ZmJmLTQxYzAtYjYwNy0zOTAwY2NiYmQyNTUiLCJpYXQiOjE3NDM1Mjk1ODcsImV4cCI6NDg5OTI4OTU4N30.1-bRbsgC6wshiiw_LwdfjoUY4eAfAjJo5B9h8Te1vN8'
              }
            }
          ).then(async res => {
            let data = await res.json()
            if (data.result) {
              setTokenHolderDatas(data.result)
            }
          })
        } else {
          await fetch(
            // `https://deep-index.moralis.io/api/v2.2/erc20/${tokenAddress}/owners?chain=0x${chainIdNum.toString(16)}&order=DESC`,
            // `https://api.routescan.io/v2/network/testnet/evm/${chainId}/erc20/${tokenAddress}/holders`,
            `https://bittensorexplorer.hotkeyswap.com/api/v2/tokens/${tokenAddress}/holders`,
            {
              method: 'GET',
              signal
              // headers: {
              //   'accept': 'application/json',
              //   'X-API-Key': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub25jZSI6IjIxNDczNDI5LTAyZDktNDZkYi1hYzA4LTBjMmUwM2Y0MGNmZSIsIm9yZ0lkIjoiMzc5NzM5IiwidXNlcklkIjoiMzkwMjA2IiwidHlwZSI6IlBST0pFQ1QiLCJ0eXBlSWQiOiIzMTNmMTM4Mi02ZmJmLTQxYzAtYjYwNy0zOTAwY2NiYmQyNTUiLCJpYXQiOjE3NDM1Mjk1ODcsImV4cCI6NDg5OTI4OTU4N30.1-bRbsgC6wshiiw_LwdfjoUY4eAfAjJo5B9h8Te1vN8'
              // }
            }
          ).then(async res => {
            let data = await res.json()
            // if (data.result) {
            //   setTokenHolderDatas(data.result)
            // }
            if (data.items) {
              setTokenHolderDatas(data.items)
            }
          })
        }
      }
    } catch (e) {
      console.error(e)
    }
    getApiLockRef.current = false
  }

  useEffect(() => {
    if (chartType !== 'native') return
    const interval = setInterval(() => getApi(), 10000)
    return () => clearInterval(interval)
  }, [chartType])

  const setMaxAmount = async () => {
    const gasPad = 0.002
    const spendable = Math.max(0, (Number(accountBalance) || 0) - gasPad)
    setAmount(inputToken === 'ETH' ? spendable : tokenBalance)
  }

  useEffect(() => {
    const FetchAmount = async () => {
      try {
        let id
        if (inputToken === 'ETH') {
          id = '1'
        } else {
          id = '0'
        }
        let amounts
        if (Number(tokenAmount) > 0) {
          amounts = await readContract(wagmiAdapter.wagmiConfig, {
            address: ChadAddress,
            abi: pumpAbi,
            functionName: 'ethOrTokenAmount',
            args: [w3.utils.toWei(String(tokenAmount), 'ether'), id],
            chainId: Number(chainId)
          })

          setTokenOutAmount(Number((Number(amounts) / 10 ** 18).toFixed(3)))
        } else {
          setTokenOutAmount('')
        }

        // setTokenOutAmount(Number((Number(amounts) / 10 ** 18).toFixed(3)))
      } catch (e) {
        console.error(e)
      }
    }
    if (creating === false) {
      FetchAmount()
    }
  }, [inputToken, tokenAmount, creating])

  // Removed unused function chanageCurrency

  useEffect(() => {
    const readTokenDecimals = async () => {
      if (!tokenAddress) return
      try {
        const d = await readContract(wagmiAdapter.wagmiConfig, {
          address: tokenAddress,
          abi: TokenAbi,
          functionName: 'decimals',
          chainId: Number(chainId)
        })
        setTokenDecimals(Number(d) || 18)
      } catch (e) {
        console.warn('decimals() read failed:', e?.message || e)
        setTokenDecimals(18)
      }
    }
    readTokenDecimals()
  }, [tokenAddress, chainId])

  useEffect(() => {
    const FetchAmount = async () => {
      try {
        let amounts
        amounts = await readContract(wagmiAdapter.wagmiConfig, {
          address: tokenAddress,
          abi: TokenAbi,
          functionName: 'balanceOf',
          args: [address],
          chainId: Number(chainId)
        })
        let allowance
        let approveAddress
        approveAddress = ChadAddress
        allowance = await readContract(wagmiAdapter.wagmiConfig, {
          address: tokenAddress,
          abi: TokenAbi,
          functionName: 'allowance',
          args: [address, approveAddress],
          chainId: Number(chainId)
        })
        setTokenAllowance(Number(allowance) / 10 ** 18)
        setTokenBalance(
          w3
            ? w3.utils.fromWei(String(amounts), 'ether')
            : String(Number(amounts) / 1e18)
        )
      } catch (e) {
        console.error(e)
      }
    }
    if (address && tokenAddress) {
      FetchAmount()
    }
  }, [tokenAddress, address, creating])

  useEffect(() => {
    const FetchHolder = async ({ signal } = {}) => {
      try {
        setIsHoldersLoading(true)
        let tokenHolder
        let tokenHolders = []

        for (let i = 0; i < holderDatas?.length; i++) {
          if (Number(chainId) !== 964) {
            tokenHolder = {
              address: holderDatas[i].owner_address,
              value: Number(holderDatas[i].percentage_relative_to_total_supply)
            }
          } else {
            tokenHolder = {
              address: holderDatas[i].address.hash,
              value: Number(holderDatas[i].value) / 10 ** 25
            }
          }
          tokenHolders.push(tokenHolder)
        }

        setTokenHolders(tokenHolders)
      } catch (e) {
        console.error(e)
      } finally {
        setIsHoldersLoading(false)
      }
    }
    const FetchTransaction = async ({ signal } = {}) => {
      try {
        setIsTransactionsLoading(true)
        let transaction
        let transactionData = []
        for (let i = 0; i < transactions?.length; i++) {
          if (Number(chainId) !== 964) {
            if (
              transactions[i]?.functionName?.includes('buyToken') ||
              transactions[i]?.functionName?.includes('sellToken') ||
              transactions[i]?.method?.includes('0xdd4549b7') ||
              transactions[i]?.method?.includes('0x7e72fb52')
            ) {
              let maker = transactions[i].from
              let type
              let amount
              // if (transactions[i]?.functionName?.includes('0xdd4549b7')) {
              if (transactions[i]?.functionName?.includes('buyToken')) {
                type = 'Buy'
              } else {
                type = 'Sell'
              }
              // amount = tokenPriceDatas[transactions?.length - (i)].usdAmount * ethPrice;
              const priceEntry = tokenPriceDatas?.[transactions?.length - i]
              if (!priceEntry || priceEntry.amount == null) {
                continue
              }
              amount = priceEntry.amount
              amount =
                '$' +
                (
                  Number(
                    w3
                      ? w3.utils.fromWei(String(amount), 'ether')
                      : String(Number(amount) / 1e18)
                  ) * ethPrice
                ).toLocaleString()
              // let date = new Date(Number(transactions[i].timeStamp) * 1000).getTime() / 1000
              if (transactions[i]?.timeStamp) {
                // Convert to number, multiply by 1000 to get milliseconds
                let date =
                  new Date(Number(transactions[i].timeStamp) * 1000).getTime() /
                  1000
                let currentDate = Date.now()
                date = currentDate / 1000 - date

                if (date > 86400) {
                  date = (date / 86400).toFixed(0) + ' days ago'
                } else if (date > 3600) {
                  date = (date / 3600).toFixed(0) + ' hours ago'
                } else if (date > 0) {
                  date = (date / 60).toFixed(0) + ' mins ago'
                } else {
                  date = ' just now'
                }
                if (date < 0) {
                  date = ' just now'
                }
                let rawTimestamp = Number(transactions[i].timeStamp) || 0
                let tx = transactions[i].hash
                transaction = {
                  Maker: maker,
                  Type: type,
                  Amount: amount,
                  Date: date,
                  Tx: tx,
                  rawTimestamp
                }
                transactionData.push(transaction)
              }
            }
          } else {
            if (
              // transactions[i].functionName.includes('buyToken') ||
              // transactions[i].functionName.includes('sellToken')
              // transactions[i]?.method.includes('0xdd4549b7') ||
              // transactions[i]?.method.includes('0x7e72fb52')
              transactions[i]?.from.hash === ChadAddress ||
              transactions[i]?.to.hash === ChadAddress
            ) {
              let maker = transactions[i].from.hash
              let type
              let amount
              // if (transactions[i].functionName.includes('0xdd4549b7')) {
              if (transactions[i]?.to.hash === ChadAddress) {
                type = 'Buy'
              } else {
                type = 'Sell'
              }
              // amount = tokenPriceDatas[transactions?.length - (i)].usdAmount * ethPrice;
              amount = tokenPriceDatas[transactions?.length - i].amount
              amount =
                '$' +
                (
                  Number(
                    w3
                      ? w3.utils.fromWei(String(amount), 'ether')
                      : String(Number(amount) / 1e18)
                  ) * ethPrice
                ).toLocaleString()
              // let date = new Date(Number(transactions[i].timeStamp) * 1000).getTime() / 1000
              let date =
                new Date(transactions[i].timestamp * 1000).getTime() / 1000
              let currentDate = Date.now()
              date = currentDate / 1000 - date
              if (date > 86400) {
                date = (date / 86400).toFixed(0) + ' days ago'
              } else if (date > 3600) {
                date = (date / 3600).toFixed(0) + ' hours ago'
              } else if (date > 0) {
                date = (date / 60).toFixed(0) + ' mins ago'
              } else {
                date = ' just now'
              }
              if (date < 0) {
                date = ' just now'
              }
              let tx = transactions[i].hash
              let rawTimestamp = Number(transactions[i].timestamp) || 0
              transaction = {
                Maker: maker,
                Type: type,
                Amount: amount,
                Date: date,
                Tx: tx,
                rawTimestamp
              }
              transactionData.push(transaction)
            }
          }
        }
        transactionData.reverse()
        setTransactionDatas(transactionData)
      } catch (e) {
        if (e?.name !== 'AbortError') console.error(e)
      } finally {
        setIsTransactionsLoading(false)
      }
    }
    // --- BEGIN REPLACEMENT: useEffect tail section for holders/tx/api fetch ---
    if (!tokenAddress) return

    let isMounted = true

    // Reset per-token markers when token changes
    if (fetchedRef.current.holdersFor !== tokenAddress)
      fetchedRef.current.holdersFor = null
    if (fetchedRef.current.txFor !== tokenAddress)
      fetchedRef.current.txFor = null
    if (fetchedRef.current.apiFor !== tokenAddress)
      fetchedRef.current.apiFor = null

    const run = async () => {
      const tasks = []

      // Holders fetch
      if (
        Array.isArray(holderDatas) &&
        holderDatas.length > 0 &&
        fetchedRef.current.holdersFor !== tokenAddress
      ) {
        setIsHoldersLoading(true)
        controllersRef.current.holders?.abort()
        controllersRef.current.holders = new AbortController()
        const signal = controllersRef.current.holders.signal
        tasks.push(
          (async () => {
            try {
              await FetchHolder({ signal })
              if (isMounted) fetchedRef.current.holdersFor = tokenAddress
            } catch (e) {
              if (e?.name !== 'AbortError') console.error(e)
            } finally {
              if (isMounted) setIsHoldersLoading(false)
            }
          })()
        )
      }

      // Transactions fetch
      if (
        transactions?.length > 0 &&
        fetchedRef.current.txFor !== tokenAddress
      ) {
        controllersRef.current.tx?.abort()
        controllersRef.current.tx = new AbortController()
        const signal = controllersRef.current.tx.signal
        tasks.push(
          (async () => {
            try {
              await FetchTransaction({ signal })
              if (isMounted) fetchedRef.current.txFor = tokenAddress
            } catch (e) {
              if (e?.name !== 'AbortError') console.error(e)
            }
          })()
        )
      }

      // Bootstrap API when we have nothing yet
      if (
        !holderDatas &&
        !transactions?.length &&
        fetchedRef.current.apiFor !== tokenAddress
      ) {
        controllersRef.current.api?.abort()
        controllersRef.current.api = new AbortController()
        const signal = controllersRef.current.api.signal
        tasks.push(
          (async () => {
            try {
              await getApi({ signal })
              if (isMounted) fetchedRef.current.apiFor = tokenAddress
            } catch (e) {
              if (e?.name !== 'AbortError') console.error(e)
            }
          })()
        )
      }

      if (tasks.length) await Promise.allSettled(tasks)
    }

    run()

    return () => {
      isMounted = false
      controllersRef.current.holders?.abort()
      controllersRef.current.tx?.abort()
      controllersRef.current.api?.abort()
    }
    // --- END REPLACEMENT ---
  }, [holderDatas, tokenAddress, transactions])

  const [selectedOption, setSelectedOption] = useState('thread')

  // Pagination State and Logic for Transactions Table
  const [currentTransactionPage, setCurrentTransactionPage] = useState(1)
  const transactionItemsPerPage = 20

  // Pagination State for Chat (Thread)
  const [chatPage, setChatPage] = useState(1)
  const chatItemsPerPage = 20

  const handleTransactionPageChange = useCallback(newPageNumber => {
    setCurrentTransactionPage(newPageNumber)
  }, [])

  // Memoized transaction page calculations and paged data
  const transactionTotalPages = useMemo(
    () => Math.ceil(transactionDatas.length / transactionItemsPerPage) || 0,
    [transactionDatas]
  )

  const pagedTransactions = useMemo(() => {
    const start = (currentTransactionPage - 1) * transactionItemsPerPage
    const end = currentTransactionPage * transactionItemsPerPage
    return transactionDatas.slice(start, end)
  }, [transactionDatas, currentTransactionPage])

  const sortedHolders = useMemo(() => {
    return Array.isArray(tokenHolders)
      ? [...tokenHolders].sort((a, b) => b.value - a.value)
      : []
  }, [tokenHolders])

  const pagedHolders = useMemo(() => {
    const start = (currentHolderPage - 1) * holderItemsPerPage
    const end = currentHolderPage * holderItemsPerPage
    return sortedHolders.slice(start, end)
  }, [sortedHolders, currentHolderPage, holderItemsPerPage])

  const holderTotalPages = useMemo(
    () => Math.ceil(sortedHolders.length / holderItemsPerPage) || 0,
    [sortedHolders, holderItemsPerPage]
  )

  const botResponse = async () => {
    if (isLoading) return
    setIsLoading(true)
    const ac = new AbortController()
    try {
      const response = await fetch(
        `${apiUrl}/api/chat/${ChadAddress}?chainId=${Number(chainId)}`,
        {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          headers: { 'Content-Type': 'application/json' },
          redirect: 'error',
          body: JSON.stringify({
            tokenAddress: ChadAddress,
            chainId: Number(chainId),
            content: messageText
          }),
          signal: ac.signal
        }
      )
      const botReply =
        response.status === 200 ? await response.json() : 'Invalid API Key'
      setBotChat(prev => [...prev, botReply])
    } catch (e) {
      if (e?.name !== 'AbortError') console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const handleScroll = ref => {
    ref.scrollTo({
      top: ref.scrollHeight,
      left: 0,
      behavior: 'smooth'
    })
  }

  const sendMessage = async () => {
    try {
      if (isLoading) return
      const text = (messageText || '').trim()
      if (!text) return

      const tokenAddressLc = (ChadAddress || '').toLowerCase()
      const chainIdNum = Number(chainId)

      // optimistic UI
      setUserChat(prev => [...prev, text])
      setMessageText('')
      setIsLoading(true)

      // Log the request payload for debugging
      console.debug('[chat] sending', {
        tokenAddress: ChadAddress,
        chainId: Number(chainId),
        content: text
      })

      const res = await fetch(
        `${apiUrl}/api/chat/${tokenAddressLc}?chainId=${chainIdNum}`,
        {
          method: 'POST',
          mode: 'cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            tokenAddress: ChadAddress,
            chainId: Number(chainId),
            content: text
          })
        }
      )

      // Diagnostic: surface backend error messages if status is not OK
      if (!res.ok) {
        try {
          const ct = res.headers.get('content-type') || ''
          if (ct.includes('application/json')) {
            const err = await res.json()
            console.warn('[chat] HTTP error', res.status, err)
          } else {
            const raw = await res.text()
            console.warn('[chat] HTTP error', res.status, raw.slice(0, 200))
          }
        } catch (_) {}
      }

      let botText = ''
      if (res.ok) {
        const ct = res.headers.get('content-type') || ''
        if (ct.includes('application/json')) {
          const data = await res.json()
          console.debug('[chat] parsed JSON', data)
          botText = extractAssistantText(data) || ''
          // Ultra-fallback: stringify a few obvious fields if still empty
          if (!botText) {
            const guess =
              data?.bot ||
              data?.reply ||
              data?.response ||
              data?.message ||
              data?.data?.bot ||
              data?.data?.reply ||
              data?.data?.message ||
              data?.choices?.[0]?.message?.content ||
              data?.choices?.[0]?.text ||
              ''
            if (typeof guess === 'string') botText = guess
          }
          if (!botText) {
            try {
              botText = JSON.stringify(data).slice(0, 300)
            } catch (_) {}
          }
        } else {
          const raw = await res.text()
          console.warn('[chat] non-JSON response', raw.slice(0, 200))
          botText = raw.slice(0, 300)
        }
      } else {
        // error already surfaced above
      }

      if (!botText) botText = '…'

      setBotChat(prev => [...prev, botText])

      requestAnimationFrame(() => {
        try {
          scrollContainer.current?.scrollTo({
            top: scrollContainer.current.scrollHeight,
            behavior: 'smooth'
          })
        } catch {}
      })
    } catch (err) {
      console.error('[chat] sendMessage error', err)
      setBotChat(prev => [...prev, 'Failed to get a response. Try again.'])
    } finally {
      setIsLoading(false)
    }
  }

  const handleEnterKey = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      sendMessage()
    }
  }

  useEffect(() => {
    if (isLoading === false) {
      focus?.current?.focus({ preventScroll: true })
    }
  }, [isLoading])

  useEffect(() => {
    handleScroll(scrollContainer.current)
  }, [userChat, botChat])

  useEffect(() => {
    if (!ChadAddress) return
    const ac = new AbortController()
    const InitChatData = async () => {
      try {
        const response = await fetch(
          `${apiUrl}/api/chat/${ChadAddress}?chainId=${Number(chainId)}`,
          { method: 'GET', signal: ac.signal }
        )
        const datas = await response.json()
        const user_chat = []
        const bot_chat = []
        datas.sort((a, b) => a.timestamp - b.timestamp)
        datas.forEach(data => {
          user_chat.push({ text: data.user, time: data.timestamp })
          bot_chat.push({ text: data.bot, time: data.timestamp })
        })
        setUserChat(user_chat)
        setBotChat(bot_chat)
      } catch (e) {
        if (e?.name !== 'AbortError') console.error(e)
      }
    }
    InitChatData()
    return () => ac.abort()
  }, [ChadAddress, chainId])

  useEffect(() => {
    if (!ChadAddress) return
    const ac = new AbortController()
    const fetchData = async () => {
      try {
        const res = await fetch(
          `${apiUrl}/api/getAgent/${ChadAddress}?chainId=${Number(chainId)}`,
          { method: 'GET', signal: ac.signal }
        )
        const data = await res.json()
        if (data === null || data.apiKey === '') setShowChat(false)
      } catch (e) {
        if (e?.name !== 'AbortError') console.error(e)
      }
    }
    fetchData()
    return () => ac.abort()
  }, [ChadAddress, chainId])

  return (
    <div>
      <div className="GlobalContainer launches-all-padding">
        <div className="flex flex-col lg:flex-row gap-y-6 lg:gap-x-6 items-start lg:min-w-[900px]">
          <div className="w-full">
            <TopBar />

            <div className="max-w-[90rem] m-auto pt-12 pb-8 px-2 relative z-[1]">
              <div className="h-20 sm:h-0" aria-hidden="true" />
              <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_380px] gap-3 items-start">
                <section className="main-left-content w-full lg:flex-1 min-w-0 overflow-visible mr-0 lg:mr-0">
                  {/* Token Intro Area */}
                  <section className="mb-2 px-3">
                    <div className="mb-2">
                      <Link
                        to="/"
                        className="inline-flex items-center gap-1 text-[#f500ff] hover:text-[#f8ffe8] hover:underline"
                      >
                        ← Go Back
                      </Link>
                    </div>
                    <div className="flex flex-wrap items-center gap-3 text-[13px] text-[#eee] mb-4">
                      {/* Token + Ticker */}
                      <span className="font-black text-[24px] tracking-widest text-[#f8ffe8] flex items-center gap-2">
                        {tokenName}{' '}
                        <span className="text-[#8f8f8f]">({tokenSymbol})</span>
                      </span>

                      {/* Dev Label (Linked) */}
                      {devAddress && (
                        <Link
                          to={`/profile/?address=${devAddress}`}
                          className="flex items-center gap-1 bg-[#2d2d2d]/60 px-2 py-1 rounded-full text-[#ffd700] hover:bg-[#2d2d2d]/80 text-[12px] font-semibold"
                        >
                          <Jazzicon
                            diameter={16}
                            seed={jsNumberForAddress(devAddress)}
                          />
                          <span>{`${devAddress.slice(
                            0,
                            6
                          )}...${devAddress.slice(-4)} (dev)`}</span>
                        </Link>
                      )}

                      {/* Created time placeholder with a sparkle icon */}
                      <span className="text-[12px] flex items-center gap-1">
                        <span className="bg-[#ffd700]/20 px-2 py-1 rounded-full text-[#ffd700] flex items-center gap-1">
                          ✨{' '}
                          {createdTime
                            ? (() => {
                                const diff = Date.now() / 1000 - createdTime
                                if (diff < 60)
                                  return `about ${Math.floor(diff)} sec ago`
                                if (diff < 3600)
                                  return `about ${Math.floor(
                                    diff / 60
                                  )} min ago`
                                if (diff < 86400)
                                  return `about ${Math.floor(
                                    diff / 3600
                                  )} hours ago`
                                if (diff < 2592000)
                                  return `about ${Math.floor(
                                    diff / 86400
                                  )} days ago`
                                if (diff < 31536000)
                                  return `about ${Math.floor(
                                    diff / 2592000
                                  )} months ago`
                                return `about ${Math.floor(
                                  diff / 31536000
                                )} years ago`
                              })()
                            : 'Loading...'}
                        </span>
                      </span>

                      {/* Market Cap bubble */}
                      {!lpCreated && (
                        <span className="text-[12px] flex items-center gap-1 bg-[#4ade80]/20 px-2 py-1 rounded-full text-[#4ade80] font-bold">
                          market cap:
                          <span className="text-[#00FF00]">
                            $
                            {(
                              ((2 * virtualLp * ethPrice) /
                                virtualTokenLp /
                                2) *
                              1000000000
                            ).toLocaleString(undefined, {
                              maximumFractionDigits: 0
                            })}
                          </span>
                        </span>
                      )}

                      {/* Replies bubble with a chat icon */}
                      <span className="text-[12px] flex items-center gap-1 px-2 py-1 rounded-full bg-[#ffd700]/10 text-[#ffd700] font-bold">
                        <svg
                          className="w-3 h-3"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M17 8h2a2 2 0 012 2v7.5A2.5 2.5 0 0118.5 20H15l-3 3-3-3H5.5A2.5 2.5 0 013 17.5V8a2 2 0 012-2h2"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M7 8h10v6H7z"
                          />
                        </svg>
                        <span className="text-[12px] flex items-center gap-1 px-2 py-1 rounded-full text-[#ffd700] font-bold">
                          replies
                          <span className="text-[#f8ffe8]">
                            {chatHistory?.length || 0}
                          </span>
                        </span>
                      </span>
                    </div>
                  </section>

                  {/* Chart Section */}
                  <section>
                    <div className="flex justify-start mb-2">
                      <div
                        className="inline-flex rounded-lg p-1.5 gap-1 bg-[#151820]/80 border border-[#2a2d36] shadow-sm backdrop-blur"
                        role="tablist"
                        aria-label="chart view"
                      >
                        <button
                          onClick={() => setChartType('native')}
                          className={`rounded-lg border px-3 py-1.5 font-medium tracking-wide text-[13px] transition-colors hover:translate-y-[-1px] ${
                            chartType === 'native'
                              ? 'border-[#a135bb] bg-[#2a2d36] text-[#f8ffe8]'
                              : 'border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8]/70 hover:bg-[#2a2d36] hover:border-[#a135bb]'
                          }`}
                        >
                          <span className="inline-flex items-center gap-1.5">
                            {/* icon */}
                            <svg
                              className="w-3.5 h-3.5"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              aria-hidden="true"
                            >
                              <path
                                d="M3 17l5-5 4 4 7-7"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            <span>hotcurves chart</span>
                          </span>
                        </button>
                        {supportsDexscreener && (
                          <button
                            onClick={() => setChartType('dexscreener')}
                            disabled={!lpCreated}
                            className={`rounded-lg border px-3 py-1.5 font-medium tracking-wide text-[13px] transition-colors hover:translate-y-[-1px] ${
                              !lpCreated
                                ? 'opacity-40 cursor-not-allowed border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8]/40'
                                : chartType === 'dexscreener'
                                ? 'border-[#a135bb] bg-[#2a2d36] text-[#f8ffe8]'
                                : 'border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8]/70 hover:bg-[#2a2d36] hover:border-[#a135bb]'
                            }`}
                          >
                            <span className="inline-flex items-center gap-1.5">
                              {/* icon */}
                              <svg
                                className="w-3.5 h-3.5"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                aria-hidden="true"
                              >
                                <path
                                  d="M6 16V8M10 16V4M14 20V10M18 20V14"
                                  strokeLinecap="round"
                                />
                              </svg>
                              <span>current chart</span>
                            </span>
                          </button>
                        )}
                      </div>
                    </div>
                    {/* Overlay chart mode toggle/legend now handled in-chart. */}

                    {/* Chart containers are kept mounted so library/state stay warm; we only toggle visibility */}
                    {/* Keep-alive chart containers: once mounted, we only hide/show */}
                    <div className="relative" style={{ minHeight: 520 }}>
                      {/* Dexscreener (always mounted when available; hidden via CSS when inactive) */}
                      {supportsDexscreener && (
                        <iframe
                          key="dexscreener"
                          src={dexSrc}
                          className={`chart absolute inset-0 ${
                            chartType === 'dexscreener' ? 'block' : 'hidden'
                          }`}
                          title="chart"
                          style={{ height: 500, width: '100%' }}
                          loading="eager"
                          referrerPolicy="no-referrer-when-downgrade"
                        />
                      )}
                      {/* Native HotCurves chart: keep it mounted at all times so the library
                        can load in the background. We overlay a skeleton while the
                        price data is still loading. */}
                      <div
                        className={`absolute inset-0 ${
                          chartType === 'native' ? 'block' : 'hidden'
                        }`}
                        style={{ height: 500, width: '100%' }}
                      >
                        {/* Native HotCurves chart instance (receives: data, timeframe mode, holders trend, dev events) */}
                        <MyChart
                          key={tokenAddress || 'native'}
                          data={displayedSeries || []}
                          ethPrice={undefined}
                          overlayControls={true}
                          mode={chartMode}
                          onModeChange={setChartMode}
                          valueKey={
                            chartMode === 'price' ? 'priceUSD' : undefined
                          }
                          fitSignal={fitBump}
                          holdersTrend={holdersTrend}
                          showHoldersMini
                          devEvents={devEvents}
                        />
                        {!hasChartData && (
                          <div className="absolute inset-0 h-[500px] w-full bg-[#333] animate-pulse rounded-lg" />
                        )}
                      </div>
                    </div>
                    {chainId === '964' && lpCreated && (
                      <div className="mb-2 rounded-2xl border border-[#2a2d36] bg-[#1d2028] px-6 py-4 text-sm leading-relaxed text-[#f8ffe8]/80">
                        Liquidity has migrated to hotkeyswap. We’re still wiring up a
                        native post-bonding feed here, so this chart will resume once
                        that goes live. Thanks for bearing with us while we finish the
                        integration.
                      </div>
                    )}
                  </section>

                  {/* Selection Button Area */}
                  <section>
                    <div className="flex justify-start mb-2">
                      <div
                        className="inline-flex rounded-lg p-1.5 gap-1 bg-[#151820]/80 border border-[#2a2d36] shadow-sm backdrop-blur"
                        role="tablist"
                        aria-label="activity view"
                      >
                        {['thread', 'trades'].map(tab => (
                          <button
                            key={tab}
                            onClick={() => setSelectedOption(tab)}
                            className={`rounded-lg border px-3 py-1.5 font-medium tracking-wide text-[13px] transition-colors hover:translate-y-[-1px] ${
                              selectedOption === tab
                                ? 'border-[#a135bb] bg-[#2a2d36] text-[#f8ffe8]'
                                : 'border-[#2a2d36] bg-[#2a2d36]/40 text-[#f8ffe8]/70 hover:bg-[#2a2d36] hover:border-[#a135bb]'
                            }`}
                          >
                            <span className="inline-flex items-center gap-1.5">
                              {tab === 'thread' ? (
                                <svg
                                  className="w-3.5 h-3.5"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M7 8h10M7 12h8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M21 12a8 8 0 01-8 8H8l-4 3v-3a8 8 0 01-8-8V8a4 4 0 014-4h10a4 4 0 014 4v4z"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  className="w-3.5 h-3.5"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M7 7l-3 3 3 3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path d="M4 10h10" strokeLinecap="round" />
                                  <path
                                    d="M17 17l3-3-3-3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path d="M20 14H10" strokeLinecap="round" />
                                </svg>
                              )}
                              <span>{tab}</span>
                            </span>
                          </button>
                        ))}
                      </div>
                    </div>

                    {/* 
                    Trades section
                  */}
                    {selectedOption === 'trades' &&
                      (isTransactionsLoading ? (
                        <section className="claim-card p-6 bg-[#171a21] text-[#f8ffe8] border border-[#2c2c2c] rounded-lg shadow-md">
                          <div className="grid grid-cols-5 text-[12px] text-[#f8ffe8]/60 border-b border-gray-700 pb-2 mb-2">
                            <span>maker</span>
                            <span>type</span>
                            <span>amount</span>
                            <span>date</span>
                            <span>tx</span>
                          </div>
                          {/* Skeleton placeholder rows */}
                          <div className="animate-pulse space-y-2">
                            {Array.from({ length: 4 }).map((_, i) => (
                              <div
                                key={i}
                                className="grid grid-cols-5 py-2.5 border-b border-gray-700"
                              >
                                <div className="h-4 bg-[#1d2028] rounded w-3/4"></div>
                                <div className="h-4 bg-[#1d2028] rounded w-1/2"></div>
                                <div className="h-4 bg-[#1d2028] rounded w-3/5"></div>
                                <div className="h-4 bg-[#1d2028] rounded w-1/2"></div>
                                <div className="h-4 bg-[#1d2028] rounded w-3/4"></div>
                              </div>
                            ))}
                          </div>
                        </section>
                      ) : (
                        <section className="claim-card p-6 bg-[#171a21] text-[#f8ffe8] border border-[#2c2c2c] rounded-lg shadow-md">
                          <div>
                            <div className="flex justify-between items-center mb-3">
                              <button
                                onClick={() =>
                                  setTradeSortOrder(prev =>
                                    prev === 'asc' ? 'desc' : 'asc'
                                  )
                                }
                                className="flex items-center gap-1 text-[13px] text-[#f500ff] hover:underline"
                              >
                                sort by time
                                <span>
                                  {tradeSortOrder === 'asc' ? '↑' : '↓'}
                                </span>
                              </button>
                            </div>
                            <div className="grid grid-cols-5 text-[12px] text-[#f8ffe8]/60 border-b border-gray-700 pb-2 mb-2">
                              <span>maker</span>
                              <span>type</span>
                              <span>amount</span>
                              <span>date</span>
                              <span>tx</span>
                            </div>
                            {!isFetchingData &&
                              transactionDatas.length === 0 && (
                                <div className="text-center text-[13px] text-gray-500">
                                  No Trades
                                </div>
                              )}
                            {Array.isArray(transactionDatas) &&
                              Array.isArray(tokenPriceDatas) &&
                              pagedTransactions.map((item, idx) => {
                                if (!item || typeof item !== 'object')
                                  return null
                                const realIndex =
                                  (currentTransactionPage - 1) *
                                    transactionItemsPerPage +
                                  idx
                                const priceIndex =
                                  transactionDatas.length - 1 - realIndex
                                const tokenPrice = tokenPriceDatas?.[priceIndex]
                                if (!tokenPrice || tokenPrice.amount == null)
                                  return null
                                const { Maker, Type, Amount, Date, Tx } = item
                                return (
                                  <div
                                    key={idx}
                                    className="grid grid-cols-5 py-2.5 border-b border-gray-700 hover:bg-[#1f2129] transition-all duration-200 text-[13px] items-center"
                                  >
                                    <a
                                      className="truncate text-[#f500ff] hover:underline"
                                      href={SCAN_LINK + 'address/' + Maker}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {Maker?.slice(0, 6)}...{Maker?.slice(-4)}
                                    </a>

                                    <div>
                                      {Type === 'Buy' ? (
                                        <span className="text-[#7CFC98] font-bold text-[12px]">
                                          buy
                                        </span>
                                      ) : (
                                        <span className="text-[#f87171] font-bold text-[12px]">
                                          sell
                                        </span>
                                      )}
                                    </div>

                                    <div className="flex flex-col justify-center w-full">
                                      <span className="text-[#f500ff] font-medium">
                                        {Amount || '-'}
                                      </span>
                                      <span className="text-[12px] text-[#f8ffe8]/60">
                                        {tokenPrice?.amount !== undefined
                                          ? (w3
                                              ? Number(
                                                  w3.utils.fromWei(
                                                    String(tokenPrice.amount),
                                                    'ether'
                                                  )
                                                ).toFixed(4)
                                              : (
                                                  Number(tokenPrice.amount) /
                                                  1e18
                                                ).toFixed(4)) +
                                            ' ' +
                                            COIN_NAME
                                          : '0'}
                                      </span>
                                    </div>
                                    <div className="text-[12px] text-[#f8ffe8]/60">
                                      {Date}
                                    </div>

                                    <a
                                      className="truncate text-[#f500ff] hover:underline"
                                      href={SCAN_LINK + 'tx/' + Tx}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {Tx?.slice(0, 6)}...{Tx?.slice(-4)}
                                    </a>
                                  </div>
                                )
                              })}
                          </div>

                          {/* Pagination */}
                          <div className="flex justify-end mt-2 gap-1">
                            <button
                              className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px]"
                              onClick={() => handleTransactionPageChange(1)}
                            >
                              «
                            </button>
                            <button
                              className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px]"
                              onClick={() =>
                                handleTransactionPageChange(
                                  Math.max(currentTransactionPage - 1, 1)
                                )
                              }
                            >
                              ‹
                            </button>
                            <span className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40">
                              {currentTransactionPage}/{transactionTotalPages}
                            </span>
                            <button
                              className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px]"
                              onClick={() =>
                                handleTransactionPageChange(
                                  Math.min(
                                    currentTransactionPage + 1,
                                    transactionTotalPages
                                  )
                                )
                              }
                            >
                              ›
                            </button>
                            <button
                              className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px]"
                              onClick={() =>
                                handleTransactionPageChange(
                                  transactionTotalPages
                                )
                              }
                            >
                              »
                            </button>
                          </div>
                        </section>
                      ))}

                    {/* Chat section */}
                    {selectedOption === 'thread' && (
                      <section className="claim-card p-6 bg-[#171a21] text-[#f8ffe8] border border-[#2c2c2c] rounded-lg shadow-md">
                        <div>
                          <div className="flex justify-between items-center mb-3">
                            <button
                              onClick={() =>
                                setChatSortOrder(prev =>
                                  prev === 'asc' ? 'desc' : 'asc'
                                )
                              }
                              className="flex items-center gap-1 text-[13px] text-[#f500ff] hover:underline"
                            >
                              sort by time
                              <span>{chatSortOrder === 'asc' ? '↑' : '↓'}</span>
                            </button>
                          </div>
                          <div className="space-y-1">
                            <div className="bg-[#1d2028] rounded-lg px-3 py-2 flex items-start gap-3 text-[13px] text-[#f8ffe8] mb-2">
                              <Jazzicon
                                diameter={16}
                                seed={jsNumberForAddress(devAddress)}
                              />
                              <div className="flex-1">
                                <div className="text-[12px] text-[#f8ffe8]/60 flex items-center gap-2">
                                  <Link
                                    to={`/profile/?address=${devAddress}`}
                                    className="hover:underline font-semibold text-[#f500ff]"
                                  >
                                    {devAddress?.slice(0, 6)}...
                                    {devAddress?.slice(-4)} (dev)
                                  </Link>
                                  <span className="text-[#f8ffe8]/60">
                                    {new Date(
                                      createdTime * 1000
                                    ).toLocaleString('en-GB')}
                                  </span>
                                </div>
                                <div className="flex items-start mt-1 gap-3">
                                  <div className="flex-shrink-0">
                                    <TokenLogoImage
                                      address={ChadAddress}
                                      chainId={chainIdNum ?? chainId}
                                      version={versionType}
                                      className="rounded-lg object-contain w-[100px] h-[100px]"
                                      alt="token logo"
                                      loading="lazy"
                                      decoding="async"
                                    />
                                  </div>
                                  <div className="flex flex-col justify-center">
                                    <div className="text-lg font-extrabold text-[#f8ffe8] leading-tight">
                                      {tokenName} ({tokenSymbol})
                                    </div>
                                    <div className="text-[12px] text-[#f8ffe8]/70 leading-tight mt-0.5">
                                      {description?.length > 120
                                        ? description.slice(0, 120) + '...'
                                        : description}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {isThreadLoading ? (
                              <div className="animate-pulse space-y-3">
                                {Array.from({ length: 3 }).map((_, i) => (
                                  <div
                                    key={i}
                                    className="bg-[#1d2028] rounded-lg px-3 py-2 flex items-start gap-3"
                                  >
                                    <div className="w-6 h-6 bg-[#3a3a3a] rounded-full" />
                                    <div className="flex-1 space-y-2">
                                      <div className="h-3 bg-[#3a3a3a] rounded w-1/4"></div>
                                      <div className="h-3 bg-[#3a3a3a] rounded w-3/4"></div>
                                      <div className="h-3 bg-[#3a3a3a] rounded w-1/2"></div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              Array.isArray(chatHistory) &&
                              chatHistory
                                .slice(
                                  (chatPage - 1) * chatItemsPerPage,
                                  chatPage * chatItemsPerPage
                                )
                                .map((item, index) => {
                                  if (!item) return null
                                  const { Sender, Content, Date } = item
                                  return (
                                    <div
                                      key={index}
                                      className="bg-[#1d2028] rounded-lg px-3 py-2 flex items-start gap-3 text-[13px] text-[#f8ffe8]"
                                    >
                                      <Jazzicon
                                        diameter={16}
                                        seed={jsNumberForAddress(Sender)}
                                      />
                                      <div className="flex-1">
                                        <div className="text-[12px] text-[#f8ffe8]/60">
                                          <Link
                                            to={`/profile/?address=${Sender}`}
                                            className="hover:underline font-semibold text-[#f500ff] mr-2"
                                          >
                                            {Sender?.slice(0, 6)}...
                                            {Sender?.slice(-4)}
                                          </Link>
                                          <span className="text-[#f8ffe8]/60">
                                            {Date}
                                          </span>
                                        </div>
                                        <p className="whitespace-pre-wrap break-words mt-0.5">
                                          {typeof Content === 'string'
                                            ? Content
                                            : Content?.text}
                                        </p>
                                      </div>
                                    </div>
                                  )
                                })
                            )}
                          </div>
                        </div>

                        <div className="flex justify-end mt-3 gap-1">
                          <button
                            className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px]"
                            onClick={() => setChatPage(1)}
                          >
                            «
                          </button>
                          <button
                            className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px]"
                            onClick={() =>
                              setChatPage(Math.max(chatPage - 1, 1))
                            }
                          >
                            ‹
                          </button>
                          <span className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40">
                            {chatPage}/
                            {Math.ceil(chatHistory.length / chatItemsPerPage)}
                          </span>
                          <button
                            className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px]"
                            onClick={() =>
                              setChatPage(
                                Math.min(
                                  chatPage + 1,
                                  Math.ceil(
                                    chatHistory.length / chatItemsPerPage
                                  )
                                )
                              )
                            }
                          >
                            ›
                          </button>
                          <button
                            className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px]"
                            onClick={() =>
                              setChatPage(
                                Math.ceil(chatHistory.length / chatItemsPerPage)
                              )
                            }
                          >
                            »
                          </button>
                        </div>

                        <div className="ButtonBox mt-6">
                          <SignMessage
                            ChadAddress={ChadAddress}
                            sender={address}
                            content={chatContent}
                            timestamp={(Date.now() / 1000).toFixed(0)}
                            chainId={Number(chainId)}
                          />
                        </div>
                      </section>
                    )}
                  </section>
                </section>

                <aside className="main-right-content block lg:col-start-2 self-start w-full lg:w-[360px] xl:w-[380px] lg:sticky">
                  {/* Swap Box */}
                  <section
                    className={`sm:static fixed bottom-0 left-0 w-full z-50 sm:bg-transparent sm:border-none`}
                  >
                    {isMobile && !isSwapOpen ? (
                      <button
                        onClick={() => setIsSwapOpen(true)}
                        className={`w-full font-bold text-lg py-4 rounded-t-xl transition-all duration-200 ${
                          activeTab === 'buy'
                            ? 'bg-[#7CFC98] text-black hover:bg-[#b1ffcb]'
                            : 'bg-[#f87171] text-white hover:bg-[#fca5a5]'
                        }`}
                      >
                        buy
                      </button>
                    ) : (
                      <>
                        {lpCreated ? (
                          <div className="claim-card relative p-6 bg-[#171a21] text-[#f8ffe8] border border-[#2c2c2c] rounded-lg shadow-md">
                            <button
                              onClick={() => setIsSwapOpen(false)}
                              className="sm:hidden absolute top-3 right-3 p-2 rounded-full bg-[#1f2129]/90 hover:bg-[#3a3a3a] text-[#f8ffe8] shadow ring-1 ring-[#2a2d36]"
                              aria-label="Close"
                            >
                              ✕
                            </button>
                            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                              <div className="flex flex-col gap-2">
                                <div className="text-xs tracking-wide text-[#f8ffe8]/60">
                                  {tokenSymbol} has bonded
                                </div>
                                <div className="text-[13px] text-[#f500ff] tracking-widest -mt-1">
                                  hotkey / {tokenSymbol}
                                </div>
                              </div>
                              <a
                                href={
                              chainIdNum === 964
                                    ? `https://taodex.hotkeyswap.com/swap?inputCurrency=&outputCurrency=${tokenAddress}`
                                    : `https://app.uniswap.org/swap?chain=${CHAIN_NAME}&inputCurrency=${getHotKeyAddress(
                                        chainIdNum
                                      )}&outputCurrency=${tokenAddress}`
                                }
                                target="_blank"
                                rel="noreferrer"
                                className="inline-flex items-center justify-center px-3 py-2 text-[13px] font-bold rounded-lg text-black bg-[#7CFC98] hover:bg-[#b1ffcb] transition-all"
                                onClick={e => {
                                  e.preventDefault()
                                  window.open(
                                    e.currentTarget.href,
                                    '_blank',
                                    'noopener,noreferrer'
                                  )
                                }}
                              >
                                swap now
                              </a>
                            </div>
                          </div>
                        ) : (
                          <div className="claim-card relative p-6 bg-[#171a21] text-[#f8ffe8] border border-[#2c2c2c] rounded-lg shadow-md">
                            <button
                              onClick={() => setIsSwapOpen(false)}
                              className="sm:hidden absolute top-3 right-3 p-2 rounded-full bg-[#1f2129]/90 hover:bg-[#3a3a3a] text-[#f8ffe8] shadow ring-1 ring-[#2a2d36]"
                              aria-label="Close"
                            >
                              ✕
                            </button>
                            <div className="flex items-center justify-between mb-4">
                              <div className="flex gap-2 w-full">
                                <button
                                  onClick={() => {
                                    setActiveTab('buy')
                                    setInputToken('ETH')
                                    setAmount(accountBalance)
                                    setAmount(tokenOutAmount)
                                  }}
                                  className={`w-full font-bold text-lg py-2 rounded-lg transition-all duration-200 ${
                                    activeTab === 'buy'
                                      ? 'bg-[#7CFC98] text-black'
                                      : 'bg-[#1f2129] text-white/60'
                                  }`}
                                >
                                  buy
                                </button>
                                <button
                                  onClick={() => {
                                    setActiveTab('sell')
                                    setInputToken('Token')
                                    setAmount(tokenBalance)
                                    setAmount(tokenOutAmount)
                                  }}
                                  className={`w-full font-bold text-lg py-2 rounded-lg transition-all duration-200 ${
                                    activeTab === 'sell'
                                      ? 'bg-[#f87171] text-white'
                                      : 'bg-[#1f2129] text-white/60'
                                  }`}
                                >
                                  sell
                                </button>
                              </div>
                            </div>
                            <section className="flex flex-col gap-4">
                              {/* Container for both input fields and swap button */}
                              <div className="w-full relative flex flex-col gap-2">
                                {/* From Field */}
                                {activeTab === 'buy' && (
                                  <>
                                    <div className="rounded-lg bg-[#1d2028] px-3 py-2 flex justify-between items-center">
                                      <div className="flex gap-3 items-center">
                                        {inputToken === 'ETH' ? (
                                          <img
                                            alt="token icon"
                                            fetchpriority="high"
                                            width="40"
                                            height="40"
                                            decoding="async"
                                            data-nimg="1"
                                            className="flex-shrink-0 w-10 h-10 rounded-full"
                                            src={ethIcon[chainId]}
                                          />
                                        ) : (
                                          <TokenLogoImage
                                            address={tokenAddress || ChadAddress}
                                            chainId={chainIdNum ?? chainId}
                                            version={versionType}
                                            className="flex-shrink-0 w-10 h-10 rounded-full"
                                            fetchpriority="high"
                                            width={40}
                                            height={40}
                                            decoding="async"
                                            data-nimg="1"
                                          />
                                        )}
                                        <div className="flex flex-col leading-none">
                                          <span className="text-[18px] font-bold text-[#f8ffe8]">
                                            {inputToken === 'ETH'
                                              ? coinNames[chainId]
                                              : tokenSymbol?.length > 8
                                              ? `${tokenSymbol.slice(0, 8)}...`
                                              : tokenSymbol}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="flex flex-col items-end w-full">
                                        <input
                                          type="number"
                                          placeholder="0"
                                          className="w-full placeholder:text-[#919191] bg-transparent focus:outline-none text-[#f8ffe8] text-[20px] font-bold text-right py-2.5 leading-[1.4]"
                                          value={tokenAmount}
                                          onChange={e =>
                                            setAmount(e.target.value)
                                          }
                                          required
                                        />
                                        <div className="flex gap-1 items-center text-[12px] text-[#919191]">
                                          <span>
                                            balance:{' '}
                                            {Number(
                                              inputToken === 'ETH'
                                                ? accountBalance
                                                : tokenBalance
                                            ).toLocaleString('en-US')}
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="flex flex-wrap justify-end items-center gap-2 w-full mt-1">
                                      {[
                                        {
                                          label: 'reset',
                                          onClick: () => setAmount('')
                                        },
                                        {
                                          label: '0.01',
                                          onClick: () => setAmount(0.01)
                                        },
                                        {
                                          label: '0.05',
                                          onClick: () => setAmount(0.05)
                                        },
                                        {
                                          label: '0.1',
                                          onClick: () => setAmount(0.1)
                                        },
                                        { label: 'max', onClick: setMaxAmount }
                                      ].map((btn, i) => (
                                        <button
                                          key={i}
                                          onClick={btn.onClick}
                                          className="px-2 py-1 rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px] text-[10px] text-[#919191] font-mono shadow-sm transition-all"
                                        >
                                          {btn.label}{' '}
                                          {i > 0 && i < 4
                                            ? coinNames[chainId]
                                            : ''}
                                        </button>
                                      ))}
                                    </div>

                                    {tokenOutAmount > 0 && (
                                      <div className="text-right text-[12px] text-[#919191] w-full">
                                        ≈{' '}
                                        {Number(tokenOutAmount).toLocaleString(
                                          'en-US',
                                          {
                                            minimumFractionDigits: 3,
                                            maximumFractionDigits: 3
                                          }
                                        )}{' '}
                                        {tokenSymbol}
                                      </div>
                                    )}
                                  </>
                                )}

                                {/* Swap Button Icon */}
                                {/*
                          <button
                            className="swap-button absolute left-1/2 top-[78px] transform -translate-x-1/2 -translate-y-1/2 bg-[#3b3b3b] hover:bg-[#333] p-2 rounded-full transition-colors"
                            onClick={chanageCurrency}
                          >
                            <img
                              alt="swap"
                              loading="lazy"
                              width="30"
                              height="30"
                              decoding="async"
                              src={swapIcon}
                            />
                          </button>
                          */}

                                {activeTab === 'sell' && (
                                  <>
                                    <div className="rounded-lg bg-[#1d2028] px-3 py-2 flex justify-between items-center">
                                      <div className="flex gap-3 items-center">
                                        <TokenLogoImage
                                          address={tokenAddress || ChadAddress}
                                          chainId={chainIdNum ?? chainId}
                                          version={versionType}
                                          fetchpriority="high"
                                          width={40}
                                          height={40}
                                          decoding="async"
                                          data-nimg="1"
                                          className="flex-shrink-0 w-10 h-10 rounded-full"
                                        />
                                        <div className="flex flex-col leading-none">
                                          <span className="text-[18px] font-bold text-[#f8ffe8]">
                                            {tokenSymbol?.length > 8
                                              ? `${tokenSymbol.slice(0, 8)}...`
                                              : tokenSymbol}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="flex flex-col items-end w-full">
                                        <input
                                          type="number"
                                          placeholder="0"
                                          className="w-full placeholder:text-[#919191] bg-transparent focus:outline-none text-[#f8ffe8] text-[20px] font-bold text-right py-2.5 leading-[1.4]"
                                          value={tokenAmount}
                                          onChange={e =>
                                            setAmount(e.target.value)
                                          }
                                          required
                                        />
                                        <div className="flex gap-1 items-center text-[12px] text-[#919191]">
                                          <span>
                                            balance:{' '}
                                            {Number(
                                              tokenBalance
                                            ).toLocaleString('en-US')}
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="flex flex-wrap justify-end items-center gap-2 w-full mt-1">
                                      {[
                                        {
                                          label: 'reset',
                                          onClick: () => setAmount('')
                                        },
                                        {
                                          label: '25%',
                                          onClick: () =>
                                            setAmount(
                                              (tokenBalance * 0.25).toFixed(4)
                                            )
                                        },
                                        {
                                          label: '50%',
                                          onClick: () =>
                                            setAmount(
                                              (tokenBalance * 0.5).toFixed(4)
                                            )
                                        },
                                        {
                                          label: '75%',
                                          onClick: () =>
                                            setAmount(
                                              (tokenBalance * 0.75).toFixed(4)
                                            )
                                        },
                                        {
                                          label: '100%',
                                          onClick: () => setAmount(tokenBalance)
                                        }
                                      ].map((btn, i) => (
                                        <button
                                          key={i}
                                          onClick={btn.onClick}
                                          className="px-2 py-1 rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px] text-[10px] text-[#919191] font-mono shadow-sm transition-all"
                                        >
                                          {btn.label}
                                        </button>
                                      ))}
                                    </div>
                                    {tokenOutAmount > 0 && (
                                      <div className="text-right text-[12px] text-[#919191] w-full">
                                        ≈{' '}
                                        {Number(tokenOutAmount).toLocaleString(
                                          'en-US',
                                          {
                                            minimumFractionDigits: 3,
                                            maximumFractionDigits: 3
                                          }
                                        )}{' '}
                                        {coinNames[chainId]}
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>

                              {/* Swap button logic */}
                              {isConnected ? (
                                Number(chainId) === currentChainId ? (
                                  <button
                                    onClick={onTokenSwap}
                                    className={`w-full font-bold text-base py-2 rounded-lg transition-all duration-200 ${
                                      inputToken !== 'ETH' &&
                                      tokenAllowance === 0 &&
                                      (!address ||
                                        Number(tokenAmount) <= 0 ||
                                        (inputToken === 'ETH' &&
                                          accountBalance <
                                            Number(tokenAmount)) ||
                                        (inputToken !== 'ETH' &&
                                          tokenBalance < Number(tokenAmount)))
                                        ? 'bg-[#2e2e2e] text-white/40 cursor-not-allowed'
                                        : activeTab === 'buy'
                                        ? 'bg-[#7CFC98] text-black hover:bg-[#b1ffcb] cursor-pointer'
                                        : 'bg-[#f87171] text-white hover:bg-[#fca5a5] cursor-pointer'
                                    }`}
                                    disabled={
                                      !address ||
                                      !tokenAmount ||
                                      Number(tokenAmount) <= 0
                                    }
                                  >
                                    {inputToken !== 'ETH' &&
                                    tokenAllowance === 0 ? (
                                      !creating ? (
                                        'approve token'
                                      ) : (
                                        <ClipLoader
                                          color="#fff"
                                          loading={creating}
                                          size={30}
                                        />
                                      )
                                    ) : !creating ? (
                                      'place trade'
                                    ) : (
                                      <ClipLoader
                                        color="#fff"
                                        loading={creating}
                                        size={30}
                                      />
                                    )}
                                  </button>
                                ) : (
                                  <button
                                    onClick={() =>
                                      openModal({ view: 'Networks' })
                                    }
                                    className={`w-full font-bold text-base py-2 rounded-lg transition-all duration-200 cursor-pointer ${
                                      activeTab === 'buy'
                                        ? 'bg-[#7CFC98] text-black hover:bg-[#b1ffcb]'
                                        : 'bg-[#f87171] text-white hover:bg-[#fca5a5]'
                                    }`}
                                  >
                                    switch network
                                  </button>
                                )
                              ) : (
                                <button
                                  onClick={() => openModal({ view: 'Connect' })}
                                  className={`w-full font-bold text-base py-2 rounded-lg transition-all duration-200 cursor-pointer ${
                                    activeTab === 'buy'
                                      ? 'bg-[#7CFC98] text-black hover:bg-[#b1ffcb]'
                                      : 'bg-[#f87171] text-white hover:bg-[#fca5a5]'
                                  }`}
                                >
                                  connect wallet to trade
                                </button>
                              )}
                            </section>
                          </div>
                        )}
                      </>
                    )}
                  </section>

                  {/* TokenDetails */}
                  <section className="mt-3">
                    <TokenDetails
                      contractAddress={ChadAddress}
                      tokenName={tokenName}
                      tokenSymbol={tokenSymbol}
                      description={description}
                      website={website}
                      twitter={twitter}
                      telegram={telegram}
                      tokenAddress={tokenAddress}
                      isTooltipDisplayed={isTokenCopied}
                      copyAddress={addr => copyTokenAddress(addr)}
                      maxWalletLimit={`${maxLimit}%`}
                      maxBuyAmount={`${(
                        (maxLimit * 1000000000) /
                        100
                      ).toLocaleString()} ${tokenSymbol}`}
                      tokenSupplyUSD={2 * virtualLp * ethPrice}
                      tokenSupplyLiquidity={virtualTokenLp}
                      volume={volume}
                      tokenPrice={tokenPrice}
                      lpCreated={lpCreated}
                      chainId={Number(chainId)}
                      versionType={versionType}
                    />
                  </section>

                  {/* Liquidity Pool Fees */}
                  {!isV2Version && (
                    <section className="mt-3">
                      <div
                        className={`claim-card p-6 bg-[#171a21] text-white border border-[#2c2c2c] rounded-lg shadow-md ${
                          lpCreated ? '' : 'hidden'
                        }`}
                      >
                        <div className="flex justify-between items-center mb-3">
                          <span className="token-info-label text-xs tracking-wide text-[#f8ffe8]/60">
                            claimed revenues
                          </span>
                          <span className="token-info-value text-[#7CFC98] text-[32px] leading-none font-extrabold">
                            {accumFee !== undefined
                              ? `$${(accumFee * ethPrice).toFixed(2)}`
                              : '-'}
                          </span>
                        </div>

                        <div className="flex justify-between items-center mb-4">
                          <h3 className="text-xs tracking-wide text-[#f8ffe8]/60">
                            unclaimed revenues
                          </h3>
                          {address?.toLowerCase() === devAddress?.toLowerCase() && (
                            <button
                              onClick={onCollectFee}
                              disabled={
                                !fee || (fee.fee0 === 0 && fee.fee1 === 0)
                              }
                              className={`inline-flex items-center justify-center px-3 py-2 text-[13px] font-bold rounded-lg text-black bg-[#7CFC98] hover:bg-[#b1ffcb] transition-all ${
                                !fee || (fee.fee0 === 0 && fee.fee1 === 0)
                                  ? 'opacity-50 cursor-not-allowed'
                                  : ''
                              }`}
                            >
                              {collecting === false ? (
                                'Collect'
                              ) : (
                                <ClipLoader
                                  color={'#000'}
                                  loading={collecting}
                                  size={20}
                                />
                              )}
                            </button>
                          )}
                        </div>

                        <div className="grid grid-cols-2 gap-2">
                          <div className="flex flex-col bg-[#1d2028] rounded-lg p-2 text-center">
                            <div className="flex items-center justify-center gap-2 mb-2">
                              <img
                                src={hotkey}
                                alt="hotkey"
                                width={24}
                                height={24}
                              />
                              <span className="text-[#f8ffe8] font-semibold text-[13px]">
                                HOTKEY
                              </span>
                            </div>
                            <span className="text-lg font-bold break-all text-[#7CFC98]">
                              {fee
                                ? getHotKeyAddress(chainIdNum) < tokenAddress
                                  ? fee.fee0.toLocaleString(undefined, {
                                      maximumFractionDigits: 2
                                    })
                                  : fee.fee1.toLocaleString(undefined, {
                                      maximumFractionDigits: 2
                                    })
                                : '-'}
                            </span>
                          </div>

                        <div className="flex flex-col bg-[#1d2028] rounded-lg p-2 text-center">
                          <div className="flex items-center justify-center gap-2 mb-2">
                            <TokenLogoImage
                              address={tokenAddress || ChadAddress}
                              chainId={chainIdNum ?? chainId}
                              version={versionType}
                              width={24}
                              height={24}
                              loading="lazy"
                              decoding="async"
                              className="w-6 h-6"
                            />
                            <span className="text-[#f8ffe8] font-semibold text-[13px]">
                              {tokenSymbol}
                            </span>
                          </div>
                          <span className="text-lg font-bold break-all text-[#7CFC98]">
                            {fee
                              ? getHotKeyAddress(chainIdNum) > tokenAddress
                                ? fee.fee0.toLocaleString(undefined, {
                                    maximumFractionDigits: 2
                                  })
                                : fee.fee1.toLocaleString(undefined, {
                                    maximumFractionDigits: 2
                                  })
                              : '-'}
                          </span>
                        </div>
                        </div>
                      </div>
                    </section>
                  )}

                  {/* AI Agent Chat */}
                  <section className="mt-3">
                    <div className={`mt-4 ${showChat ? 'block' : 'hidden'}`}>
                      <div className="claim-card relative p-6 bg-[#171a21] text-[#f8ffe8] border border-[#2c2c2c] rounded-lg shadow-md">
                        <div className="flex items-center gap-3 mb-4">
                          <TokenLogoImage
                            address={tokenAddress || ChadAddress}
                            chainId={chainIdNum ?? chainId}
                            version={versionType}
                            alt="token"
                            className="w-10 h-10 rounded-full"
                            loading="lazy"
                            decoding="async"
                          />
                          <span className="text-sm text-[#f8ffe8]/80">
                            {tokenSymbol.toUpperCase()} agent
                          </span>
                        </div>

                        <div
                          className="bg-[#1d2028] rounded-lg px-3 py-2.5 h-[200px] overflow-auto space-y-3 text-[13px]"
                          ref={scrollContainer}
                        >
                          {userChat.map((ele, key) => (
                            <div key={`blockchat-${key}`}>
                              <div className="flex justify-end">
                                <div className="bg-[#171a21] text-[12px] text-[#f8ffe8] px-3 py-2 rounded-lg max-w-[70%] break-words shadow-md">
                                  {typeof ele === 'string' ? ele : ele?.text}
                                </div>
                              </div>

                              {botChat[key] && (
                                <div className="flex justify-start mt-1">
                                  <div className="bg-[#171a21] text-[12px] text-[#f8ffe8] px-3 py-2 rounded-lg max-w-[70%] break-words shadow-inner">
                                    {typeof botChat[key] === 'string'
                                      ? botChat[key]
                                      : botChat[key]?.text}
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                          {isLoading && (
                            <div className="text-[13px] tracking-wide text-[#f8ffe8]">
                              Agent typing...
                            </div>
                          )}
                        </div>

                        <div className="relative flex justify-center">
                          <div className="py-2 flex items-stretch gap-2 w-full max-w-md">
                            <textarea
                              ref={focus}
                              disabled={isLoading}
                              value={messageText}
                              onChange={e => setMessageText(e.target.value)}
                              onKeyUp={handleEnterKey}
                              className="flex-1 h-[44px] bg-[#1d2028] text-[13px] tracking-wide text-[#f8ffe8] px-3 py-2.5 rounded-[8px] outline-none resize-none placeholder:text-[#919191] border border-[#2a2d36] focus:border-[#a135bb]"
                              placeholder="type something..."
                            />
                            <button
                              onClick={sendMessage}
                              className="inline-flex justify-center items-center rounded-[8px] border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px] w-[44px] h-[44px]"
                              aria-label="Send message"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="w-5 h-5 text-[#f8ffe8]"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                                aria-hidden="true"
                              >
                                <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  {/* Referral section */}
                  <section className="mt-3">
                    <div className="claim-card p-6 bg-[#171a21] text-[#f8ffe8] border border-[#2c2c2c] rounded-lg shadow-md">
                      <div className="flex justify-between items-center mb-3">
                        <span className="token-info-label text-xs tracking-wide text-[#f8ffe8]/60">
                          referral reward
                        </span>
                        <div className="flex items-baseline gap-2">
                          <div className="text-[32px] leading-none font-extrabold text-[#f8ffe8]">
                            0.5%
                          </div>
                        </div>
                      </div>
                      <div className="mb-4">
                        <p className="text-sm text-[#f8ffe8]/80">
                          earn <span className="font-semibold">0.5%</span> of
                          each trade using your referral link.
                        </p>
                      </div>
                      <div className="rounded-[10px] border border-[#2a2d36] bg-[#171a21] px-3 py-2 flex items-center gap-2">
                        <span className="text-[12px] text-[#f8ffe8] truncate flex-1">
                          {isReferralCopied ? 'Copied' : referlink}
                        </span>
                        <button
                          className="inline-flex justify-center items-center px-3 py-1.5 rounded-[8px] border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-all"
                          onClick={copyReferralAddress(referlink)}
                          aria-label="Copy referral link"
                        >
                          <img src={CopyIcon} alt="copy" />
                        </button>
                      </div>

                      {typeof refUserAmount === 'number' && (
                        <div className="mt-3 grid grid-cols-3 gap-2">
                          <div className="flex flex-col bg-[#1d2028] rounded-lg p-2 text-center">
                            <span className="token-info-label text-xs text-gray-400 mb-1">
                              total earned:
                            </span>
                            <span className="token-info-value text-[12px] text-[#f8ffe8]">
                              {Number(totalRefAmounts).toFixed(3)}
                              <br />
                              {coinNames[chainId]}
                            </span>
                          </div>
                          <div className="flex flex-col bg-[#1d2028] rounded-lg p-2 text-center">
                            <span className="token-info-label text-xs text-gray-400 mb-1">
                              total unique referred:
                            </span>
                            <span className="token-info-value text-[12px] text-[#f8ffe8]">
                              {refCounts}
                            </span>
                          </div>
                          <div className="flex flex-col bg-[#1d2028] rounded-lg p-2 text-center">
                            <span className="token-info-label text-xs text-gray-400 mb-1">
                              my earnings:
                            </span>
                            <span className="token-info-value text-[12px] text-[#f8ffe8]">
                              {Number(refUserAmount).toFixed(3)}
                              <br />
                              {coinNames[chainId]}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </section>

                  {/* Holders Distribution */}
                  <section className="mt-3">
                    <div className="claim-card p-6 bg-[#171a21] text-[#f8ffe8] border border-[#2c2c2c] rounded-lg shadow-md">
                      <h2 className="text-xl font-bold mb-3">
                        holders distribution
                      </h2>
                      <div className="bg-[#1d2028] rounded-lg p-3 divide-y divide-[#3b3b3b]">
                        {isHoldersLoading
                          ? [...Array(10)].map((_, index) => (
                              <div
                                key={index}
                                className="flex items-center justify-between py-2 px-2 hover:bg-[#22252f] transition-colors"
                              >
                                <div className="flex items-center gap-2">
                                  <span className="text-[12px] text-[#f8ffe8]/60 mr-3 w-6 text-right inline-block">
                                    {index + 1}.
                                  </span>
                                  <div className="w-5 h-5 rounded-full bg-[#3b3b3b]" />
                                  <div className="h-3 bg-[#3b3b3b] rounded w-24" />
                                </div>
                                <div className="h-3 bg-[#3b3b3b] rounded w-10" />
                              </div>
                            ))
                          : pagedHolders.map(({ address, value }, index) => {
                              const isDev =
                                address.toLowerCase() ===
                                devAddress?.toLowerCase()
                              const isHotCurvesContract =
                                address.toLowerCase() ===
                                ChadAddress.toLowerCase()
                              return (
                                <div
                                  key={index}
                                  className="flex items-center justify-between py-2 px-2 hover:bg-[#22252f] transition-colors"
                                >
                                  <div className="flex items-center gap-2">
                                    <span className="text-[12px] text-[#f8ffe8]/60 mr-3 w-6 text-right inline-block">
                                      {(currentHolderPage - 1) *
                                        holderItemsPerPage +
                                        index +
                                        1}
                                      .
                                    </span>
                                    <Jazzicon
                                      diameter={20}
                                      seed={jsNumberForAddress(address)}
                                    />
                                    <a
                                      href={`${scanLinks[chainId]}address/${address}`}
                                      target="_blank"
                                      rel="noreferrer"
                                      className="hover:underline text-[12px] text-[#f500ff]"
                                    >
                                      {address.slice(0, 6)}...
                                      {address.slice(-4)}
                                    </a>
                                    {isDev && (
                                      <div className="ml-1 mt-1">
                                        <span className="block text-[10px] px-2 py-0.5 rounded-full bg-[#ffd700]/20 text-[#ffd700] font-semibold tracking-wide w-fit">
                                          dev
                                        </span>
                                      </div>
                                    )}
                                    {isHotCurvesContract && (
                                      <div className="ml-1 mt-1">
                                        <span className="block text-[10px] px-2 py-0.5 rounded-full bg-[#7CFC98]/20 text-[#7CFC98] font-semibold tracking-wide w-fit">
                                          curve
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  <span className="text-[12px] text-[#d9d9d9]">
                                    {value.toFixed(2)}%
                                  </span>
                                </div>
                              )
                            })}
                      </div>
                      <div className="flex justify-end mt-2 gap-1">
                        <button
                          className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px]"
                          onClick={() => handleHolderPageChange(1)}
                        >
                          «
                        </button>
                        <button
                          className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px]"
                          onClick={() =>
                            handleHolderPageChange(
                              Math.max(currentHolderPage - 1, 1)
                            )
                          }
                        >
                          ‹
                        </button>
                        <span className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40">
                          {currentHolderPage}/{holderTotalPages}
                        </span>
                        <button
                          className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px]"
                          onClick={() =>
                            handleHolderPageChange(
                              Math.min(currentHolderPage + 1, holderTotalPages)
                            )
                          }
                        >
                          ›
                        </button>
                        <button
                          className="px-2 py-1 text-[12px] inline-flex justify-center items-center rounded-lg border border-[#2a2d36] bg-[#2a2d36]/40 hover:bg-[#2a2d36] hover:border-[#a135bb] transition-colors hover:translate-y-[-1px]"
                          onClick={() =>
                            handleHolderPageChange(holderTotalPages)
                          }
                        >
                          »
                        </button>
                      </div>
                    </div>
                  </section>
                </aside>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default App
